<div class="pv2-editor-page"
     [class.is-embedded]="embedded"
     [class.is-group-detail-surface]="isGroupDetailSurface"
     [class.is-batch-price-mode]="isBatchPriceMode"
     *ngIf="editor; else editorLoading">
  <header class="pv2-editor-header"
          [class.is-adicional-dirty]="isGroupDetailSurface && adicionalActionBarState?.saveFooterState === 'dirty'"
          [class.is-adicional-saving]="isGroupDetailSurface && adicionalActionBarState?.saveFooterState === 'saving'"
          [class.is-adicional-saved]="isGroupDetailSurface && adicionalActionBarState?.saveFooterState === 'saved'">
    <button type="button" class="pv2-back-btn" (click)="goBack()">
      <span class="fa fa-times"></span>
      <span class="pv2-back-label">Fechar</span>
    </button>

    <div class="pv2-editor-heading">
      <h1>{{ isGroupDetailSurface ? (focusedGroup?.name || 'Novo adicional') : (editor.name || 'Novo produto') }}</h1>
      <span class="pv2-save-state"
            [class.is-muted]="!isGroupDetailSurface && saveStateMuted"
            *ngIf="(!isGroupDetailSurface && saveState) || (isGroupDetailSurface && adicionalActionBarState?.creationPhase === 'full' && (adicionalActionBarState?.saveFooterState === 'saving' || adicionalActionBarState?.saveFooterState === 'saved'))">
        <ng-container *ngIf="!isGroupDetailSurface">
          {{ saveState }}
        </ng-container>
        <ng-container *ngIf="isGroupDetailSurface">
          <ng-container [ngSwitch]="adicionalActionBarState?.saveFooterState">
            <span *ngSwitchCase="'saving'">Salvando...</span>
            <span *ngSwitchCase="'saved'">Salvo</span>
            <span *ngSwitchDefault></span>
          </ng-container>
        </ng-container>
      </span>
    </div>

    <div class="pv2-editor-actions" *ngIf="!isGroupDetailSurface && !isNewProduct">
      <button type="button" class="pv2-ghost-btn" (click)="openHistorico()" kendoTooltip title="Histórico de alterações">
        <span class="fas fa-clock"></span>
      </button>
      <button type="button" class="pv2-primary-btn pv2-dark-btn" (click)="openPreview()">Visualizar</button>
    </div>

    <!-- Adicional delete button in header -->
    <button type="button" class="pv2-header-delete-btn"
            *ngIf="isGroupDetailSurface && focusedGroup && adicionalActionBarState?.creationPhase === 'full'"
            (click)="onAdicionalRequestDelete()"
            [disabled]="!podeEditarEstruturaAdicional"
            [title]="focusedGroup.shared ? 'Remover deste produto' : 'Excluir adicional'">
      <span class="fa fa-trash"></span>
    </button>

    <!-- Adicional save actions in header -->
    <div class="pv2-editor-actions pv2-editor-actions--adicional"
         *ngIf="isGroupDetailSurface && adicionalActionBarState?.creationPhase === 'full'">
      <button type="button" class="pv2-ghost-btn pv2-ghost-btn--compact"
              *ngIf="adicionalActionBarState.saveFooterState === 'dirty' || adicionalActionBarState.saveFooterState === 'saving'"
              [disabled]="adicionalActionBarState.saveFooterState === 'saving'"
              (click)="onAdicionalActionBarSave()">
        <span class="fa fa-spinner fa-spin" *ngIf="adicionalActionBarState.saveFooterState === 'saving'"></span>
        Salvar
      </button>
      <button type="button" class="pv2-primary-btn pv2-header-save-btn"
              *ngIf="adicionalActionBarState.saveFooterState === 'dirty' || adicionalActionBarState.saveFooterState === 'saving'"
              [disabled]="adicionalActionBarState.saveFooterState === 'saving'"
              (click)="onAdicionalActionBarSaveAndClose()">
        Salvar e Fechar
      </button>
    </div>
  </header>

  <div class="pv2-network-catalog-alert" *ngIf="deveExibirAvisoCatalogoRede">
    <span class="fa fa-lock"></span>
    <div>
      <strong>Produto controlado pelo catálogo da rede</strong>
      <p>Nome, descrição, categoria, fotos, adicionais e demais dados estruturais são administrados no Admin Rede. Para alterar essas informações, solicite a edição ao responsável pelo catálogo da rede.</p>
      <small>{{ textoPermissoesCatalogoRede }}</small>
    </div>
  </div>

  <nav class="pv2-editor-tabs" *ngIf="!isGroupDetailSurface" role="tablist" aria-label="Etapas do cadastro do produto">
    <button type="button" role="tab"
            [class.is-active]="activeProductTab === 'info'"
            [attr.aria-selected]="activeProductTab === 'info'"
            (click)="setProductTab('info')">
      <span class="fa fa-info-circle"></span>
      Básico
    </button>
    <button type="button" role="tab" *ngIf="rodizio"
            [class.is-active]="activeProductTab === 'cobertura'"
            [attr.aria-selected]="activeProductTab === 'cobertura'"
            [disabled]="isProductTabDisabled('cobertura')"
            [attr.title]="getProductTabDisabledHint('cobertura')"
            (click)="setProductTab('cobertura')">
      <span class="fa fa-check-square-o"></span>
      Cobertura
    </button>
    <button type="button" role="tab" *ngIf="!informativo"
            [class.is-active]="activeProductTab === 'pricing'"
            [attr.aria-selected]="activeProductTab === 'pricing'"
            [disabled]="isProductTabDisabled('pricing')"
            [attr.title]="getProductTabDisabledHint('pricing')"
            (click)="setProductTab('pricing')">
      <span class="fa fa-tag"></span>
      Preço e promoção
    </button>
    <button type="button" role="tab"
            [class.is-active]="activeProductTab === 'photos'"
            [attr.aria-selected]="activeProductTab === 'photos'"
            (click)="setProductTab('photos')">
      <span class="fa fa-camera"></span>
      Fotos
    </button>
    <button type="button" role="tab" *ngIf="!informativo && !rodizio"
            [class.is-active]="activeProductTab === 'adicionais'"
            [attr.aria-selected]="activeProductTab === 'adicionais'"
            [disabled]="isProductTabDisabled('adicionais')"
            [attr.title]="getProductTabDisabledHint('adicionais')"
            (click)="setProductTab('adicionais')">
      <span class="fa fa-list-ul"></span>
      Adicionais
      <span class="pv2-editor-tabs__count" *ngIf="!isNewProduct">{{ editor.groups.length }}</span>
    </button>
    <button type="button" role="tab"
            [class.is-active]="activeProductTab === 'availability'"
            [attr.aria-selected]="activeProductTab === 'availability'"
            [disabled]="isProductTabDisabled('availability')"
            [attr.title]="getProductTabDisabledHint('availability')"
            (click)="setProductTab('availability')">
      <span class="fa fa-calendar-check-o"></span>
      Disponibilidade
    </button>
    <button type="button" role="tab" *ngIf="temAbaFiscal && !informativo"
            [class.is-active]="activeProductTab === 'fiscal'"
            [attr.aria-selected]="activeProductTab === 'fiscal'"
            [disabled]="isProductTabDisabled('fiscal')"
            [attr.title]="getProductTabDisabledHint('fiscal')"
            (click)="setProductTab('fiscal')">
      <span class="fa fa-file-text-o"></span>
      Fiscal e integrações
    </button>
  </nav>

  <div class="pv2-editor-shell">
    <main class="pv2-editor-canvas">
      <section class="pv2-save-error" *ngIf="saveError" role="alert">
        <span class="pv2-save-error__icon"><span class="fa fa-exclamation-triangle"></span></span>
        <div class="pv2-save-error__text">
          <strong>Não foi possível salvar</strong>
          <p>{{ saveError.message }}</p>
        </div>
        <div class="pv2-save-error__actions">
          <button type="button" class="pv2-primary-btn" *ngIf="canRetrySave"
                  [disabled]="saveRetrying" (click)="retryFailedSave()">
            <span class="fa fa-spinner fa-spin" *ngIf="saveRetrying"></span>
            {{ saveRetrying ? 'Tentando...' : 'Tentar de novo' }}
          </button>
          <button type="button" class="pv2-ghost-btn" (click)="dismissSaveError()">Fechar</button>
        </div>
      </section>

      <ng-container *ngIf="!isGroupDetailSurface; else adicionalEditorTpl">
        <section class="pv2-created-banner" *ngIf="justCreated && !isNewProduct && activeProductTab === 'info'" role="status">
          <span class="pv2-created-banner__icon"><span class="fa fa-check"></span></span>
          <div class="pv2-created-banner__text">
            <strong>Produto criado</strong>
            <p>A partir de agora cada alteração é salva sozinha, sem botão de salvar. Próximos passos:</p>
          </div>
          <div class="pv2-created-banner__actions">
            <button type="button" class="pv2-secondary-btn" (click)="goToNextStepAfterCreation('photos')">
              <span class="fa fa-camera"></span> Adicionar fotos
            </button>
            <button type="button" class="pv2-primary-btn" (click)="goToNextStepAfterCreation('adicionais')">
              <span class="fa fa-list-ul"></span> Configurar adicionais
            </button>
          </div>
          <button type="button" class="pv2-created-banner__close" (click)="dismissCreatedBanner()" aria-label="Fechar aviso">
            <span class="fa fa-times"></span>
          </button>
        </section>

        <section class="pv2-creation-form" *ngIf="activeProductTab === 'info' && editor.type === 'kit' && !editor.raw.configKit">
          <h2 class="pv2-creation-form__title">Composição do kit</h2>
          <p class="pv2-field-error" *ngIf="kitSemComposicao" role="alert">{{ kitPendente || isNewProduct ? 'Este produto ainda não é kit: ele só vira kit quando o primeiro grupo “Composição do kit” for salvo na aba Adicionais.' : 'Kit sem composição: não dá para salvar nem vender até cadastrar um grupo “Composição do kit” na aba Adicionais.' }}</p>
          <p>Cadastre cada parte na aba Adicionais usando “Composição do kit”. Por exemplo: 100 salgados, 50 docinhos e 1 refrigerante.</p>
          <p>O preço deste produto é a base do pacote. Quantidades e distribuição são configuradas em cada grupo.</p>
        </section>
        <section class="pv2-creation-form" *ngIf="activeProductTab === 'info' && editor.type === 'kit' && editor.raw.configKit as kit">
          <h2 class="pv2-creation-form__title">Montagem por quantidade</h2>
          <fieldset [disabled]="!podeEditarProdutos">
            <label class="pv2-form-field">Forma de venda
              <select [(ngModel)]="kit.modalidadeQuantidade" (ngModelChange)="alterarModalidadeKit()">
                <option value="FECHADA">Quantidade fechada</option>
                <option value="ESCOLHIDA_PELO_CLIENTE">Quantidade escolhida pelo cliente</option>
              </select>
            </label>
            <div class="pv2-form-row" *ngIf="kit.modalidadeQuantidade === 'ESCOLHIDA_PELO_CLIENTE'">
              <label class="pv2-form-field">Mínimo de unidades<input type="number" min="1" step="1" [(ngModel)]="kit.qtdeMinimaCompra" (blur)="onBasicInfoChange()"></label>
              <label class="pv2-form-field">Máximo por montagem (opcional)<input type="number" [min]="kit.qtdeMinimaCompra" step="1" [(ngModel)]="kit.qtdeMaximaCompra" (blur)="onBasicInfoChange()"><small>Em branco: sem teto por montagem.</small></label>
              <label class="pv2-form-field">Aumentar de quantas em quantas?<input type="number" min="1" step="1" [(ngModel)]="kit.incrementoCompra" (blur)="onBasicInfoChange()"></label>
              <label class="pv2-form-field">O preço do produto corresponde a quantas unidades?<input type="number" min="1" step="1" [(ngModel)]="kit.qtdeUnidadesReferencia" (blur)="onBasicInfoChange()"></label>
            </div>
            <ng-container *ngIf="kit.modalidadeQuantidade === 'FECHADA'">
              <h3>Quantidades e preços</h3>
              <div class="pv2-form-row" *ngFor="let t of editor.raw.tamanhos">
                <label class="pv2-form-field">Nome<input [(ngModel)]="t.descricao" (blur)="onBasicInfoChange()"></label>
                <label class="pv2-form-field">Unidades<input type="number" min="1" step="1" [(ngModel)]="t.qtdeUnidades" (blur)="onBasicInfoChange()"></label>
                <label class="pv2-form-field">Preço<input type="number" min="0" step="0.01" [(ngModel)]="t.preco" (blur)="onBasicInfoChange()"></label>
                <label class="pv2-form-field">Preço promocional<input type="number" min="0" step="0.01" [(ngModel)]="t.novoPreco" (blur)="onBasicInfoChange()"></label>
                <label class="pv2-form-field">Código PDV<input [(ngModel)]="t.codigoPdv" (blur)="onBasicInfoChange()"></label>
                <label><input type="checkbox" [(ngModel)]="t.disponivel" (ngModelChange)="onBasicInfoChange()"> Disponível</label>
              </div>
              <button type="button" class="pv2-secondary-btn" (click)="adicionarQuantidadeKit()">Adicionar quantidade</button>
            </ng-container>
            <label class="pv2-form-field">Grupo de sabores
              <select [(ngModel)]="kit.adicionalSaboresId" (ngModelChange)="onBasicInfoChange()">
                <option [ngValue]="null">Selecione um grupo de adicionais</option>
                <ng-container *ngFor="let grupo of editor.groups">
                  <option *ngIf="grupo.raw?.tipo === 'multipla-escolha'" [ngValue]="grupo.raw.id">{{grupo.name}}</option>
                </ng-container>
              </select>
              <small>Cadastre ou vincule os sabores na aba Adicionais. O valor da opção é o extra por unidade.</small>
            </label>
            <div class="pv2-form-row">
              <label class="pv2-form-field">Mínimo por sabor<input type="number" min="1" step="1" [(ngModel)]="kit.qtdeMinimaPorSabor" (blur)="onBasicInfoChange()"></label>
              <label class="pv2-form-field">Máximo de sabores (opcional)<input type="number" min="1" step="1" [(ngModel)]="kit.qtdeMaximaDeSabores" (blur)="onBasicInfoChange()"></label>
            </div>
          </fieldset>
        </section>
        <section class="pv2-rodizio-aviso" *ngIf="rodizio && activeProductTab === 'info'" role="note">
          <span class="fa fa-refresh" aria-hidden="true"></span>
          <p><strong>Rodízio</strong> é lançado pelo atendente na comanda da mesa, com a quantidade de pessoas. Não aparece
            na loja nem no delivery. Depois de salvar, use a aba <strong>Cobertura</strong> para dizer o que sai sem preço.</p>
        </section>

        <section class="pv2-rodizio-cobertura" *ngIf="activeProductTab === 'cobertura'">
          <header>
            <h3>O que o rodízio inclui</h3>
            <p>Produtos das categorias marcadas saem sem preço para quem está neste rodízio. Adicional pago continua cobrado.
              Peças só do rodízio podem ser cadastradas sem preço numa categoria própria: elas só aparecem para quem entrou.</p>
          </header>
          <p class="pv2-rodizio-cobertura__estado" *ngIf="carregandoCobertura">Carregando categorias…</p>
          <p class="pv2-field-error" *ngIf="erroCobertura" role="alert">{{ erroCobertura }}</p>
          <ul class="pv2-rodizio-cobertura__lista" *ngIf="!carregandoCobertura">
            <li *ngFor="let categoria of coberturaRodizio" [class.is-incluida]="categoria.incluida">
              <label class="pv2-rodizio-cobertura__categoria">
                <input type="checkbox" [(ngModel)]="categoria.incluida" [disabled]="!podeEditarProdutos">
                <span>{{ categoria.nome }}</span>
              </label>
              <label class="pv2-rodizio-cobertura__maximo" *ngIf="categoria.incluida">
                <span>Máx. por pessoa</span>
                <input type="number" min="1" step="1" placeholder="À vontade" [(ngModel)]="categoria.maximoPorPessoa"
                       [disabled]="!podeEditarProdutos" [attr.aria-label]="'Máximo por pessoa em ' + categoria.nome">
              </label>
            </li>
          </ul>
          <label class="pv2-rodizio-cobertura__pendente" *ngIf="!carregandoCobertura">
            <span>Máximo de peças a caminho por vez</span>
            <input type="number" min="1" step="1" placeholder="Sem limite" [(ngModel)]="maximoPendenteRodizio"
                   [disabled]="!podeEditarProdutos" aria-label="Máximo de peças a caminho por vez">
            <small>Peças incluídas que a mesa pode ter na cozinha ao mesmo tempo. A próxima rodada libera quando ficam prontas, ou 20 minutos depois.</small>
          </label>
          <footer>
            <small>{{ categoriasIncluidasNoRodizio }} {{ categoriasIncluidasNoRodizio === 1 ? 'categoria incluída' : 'categorias incluídas' }}. Vazio no máximo = à vontade.</small>
            <button type="button" class="pv2-primary-btn" (click)="salveCoberturaRodizio()"
                    [disabled]="salvandoCobertura || carregandoCobertura || !podeEditarProdutos">
              {{ salvandoCobertura ? 'Salvando…' : 'Salvar cobertura' }}
            </button>
          </footer>
        </section>

        <section class="pv2-creation-form" *ngIf="activeProductTab === 'info'">
          <div class="pv2-creation-form__header">
            <div>
              <h2 class="pv2-creation-form__title">{{ isNewProduct ? 'Informações principais' : 'Informações do produto' }}</h2>
              <p class="pv2-creation-form__subtitle">{{ isNewProduct ? 'Preencha os dados essenciais para criar o produto no catálogo.' : 'As alterações são salvas automaticamente.' }}</p>
            </div>
            <!-- Trocar o tipo é ação rara: fica discreta, no canto do cabeçalho, e não entre as abas e o formulário. -->
            <div class="pv2-creation-form__converter" *ngIf="!isNewProduct && editor.type === 'normal' && podeEditarProdutos">
              <span>Converter em</span>
              <button type="button" (click)="converterEmKit()"><i class="fa fa-box"></i> Kit</button>
              <button type="button" (click)="converterEmInformativo()"><i class="fa fa-info-circle"></i> Informativo</button>
            </div>
          </div>

          <div class="pv2-creation-form__body">
            <div class="pv2-creation-form__fields">
              <div class="pv2-creation-form__row--2col">
                <label class="pv2-creation-form__field" data-creation-field="name" [class.is-invalid]="creationErrors.name">
                  <span>Nome do produto {{ isNewProduct ? '*' : '' }}</span>
                  <input class="pv2-creation-form__name-input" [(ngModel)]="editor.name"
                         (ngModelChange)="onBasicInfoChange()" placeholder="Ex: X-Burger Especial" type="text"
                         [attr.aria-invalid]="creationErrors.name ? true : null"
                         [disabled]="!podeEditarProdutos">
                  <small class="pv2-field-error" *ngIf="creationErrors.name">{{ creationErrors.name }}</small>
                </label>
                <label class="pv2-creation-form__field" *ngIf="!informativo">
                  <span>Código PDV</span>
                  <input [(ngModel)]="editor.codigoPdv" (ngModelChange)="onBasicInfoChange()" type="text"
                         [disabled]="!podeEditarProdutos">
                </label>
              </div>
              <div class="pv2-creation-form__row--3col" *ngIf="!informativo">
                <label class="pv2-creation-form__field" *ngIf="!temModuloTabelaPrecos && editor.type !== 'pizza'" data-creation-field="basePrice" [class.is-invalid]="creationErrors.basePrice">
                  <span>{{ rodizio ? 'Preço por pessoa (R$)' : 'Preço Base (R$)' }} {{ isNewProduct ? '*' : '' }}</span>
                  <kendo-numerictextbox
                    [(ngModel)]="editor.basePrice"
                    (ngModelChange)="onBasicInfoChange()"
                    [min]="0"
                    [format]="obtenhaFormatoPrecoV2()"
                    [disabled]="!podeEditarPrecos">
                  </kendo-numerictextbox>
                  <small class="pv2-field-error" *ngIf="creationErrors.basePrice">{{ creationErrors.basePrice }}</small>
                </label>
                <div class="pv2-creation-form__field" *ngIf="temModuloTabelaPrecos">
                  <span>Preços</span>
                  <button type="button" class="pv2-secondary-btn" (click)="verPrecosTabela()" [disabled]="!editor.id">
                    <i class="fa fa-tags"></i>
                    Ver preços
                  </button>
                </div>
                <label class="pv2-creation-form__field">
                  <span>Vendido por</span>
                  <kendo-dropdownlist
                    [data]="['Unidade', 'Peso']"
                    [(ngModel)]="editor.tipoDeVenda"
                    (ngModelChange)="onBasicInfoChange()"
                    [disabled]="!podeEditarProdutos">
                  </kendo-dropdownlist>
                </label>
                <label class="pv2-creation-form__field" *ngIf="!vendidoPorPeso">
                  <span>Incremento</span>
                  <kendo-numerictextbox
                    [(ngModel)]="editor.incremento"
                    (ngModelChange)="onBasicInfoChange()"
                    [min]="1"
                    [format]="'n0'"
                    [disabled]="!podeEditarProdutos">
                  </kendo-numerictextbox>
                  <small class="pv2-field-note">De quantas em quantas unidades o + e o - andam. 1 = de um em um.</small>
                </label>
              </div>
              <div class="pv2-creation-form__field" data-creation-field="categoryId" [class.is-invalid]="creationErrors.categoryId">
                <span>Categoria {{ isNewProduct ? '*' : '' }}</span>
                <kendo-dropdownlist
                  [data]="categorias"
                  [textField]="'nome'"
                  [valueField]="'id'"
                  [valuePrimitive]="true"
                  [defaultItem]="{ id: null, nome: 'Selecionar categoria...' }"
                  [(ngModel)]="editor.categoryId"
                  (ngModelChange)="onBasicInfoChange()"
                  [popupSettings]="{ animate: true }"
                  [disabled]="!podeEditarProdutos"
                ></kendo-dropdownlist>
                <small class="pv2-field-error" *ngIf="creationErrors.categoryId">{{ creationErrors.categoryId }}</small>
                <button type="button" class="pv2-new-category__toggle" *ngIf="!newCategoryOpen && podeEditarProdutos" (click)="openNewCategory()">
                  <i class="fa fa-plus"></i>
                  Nova categoria
                </button>
                <div class="pv2-new-category" *ngIf="newCategoryOpen">
                  <input type="text" [(ngModel)]="newCategoryName" maxlength="80" placeholder="Nome da categoria"
                         (keydown.enter)="$event.preventDefault(); saveNewCategory()" (keydown.escape)="cancelNewCategory()">
                  <button type="button" class="is-primary" (click)="saveNewCategory()" [disabled]="!newCategoryName.trim() || savingCategory">
                    <i class="fa" [ngClass]="savingCategory ? 'fa-spinner fa-spin' : 'fa-check'"></i>
                    Criar
                  </button>
                  <button type="button" (click)="cancelNewCategory()" [disabled]="savingCategory" aria-label="Cancelar">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
              <label class="pv2-creation-form__field">
                <span>Descrição <small>(opcional)</small></span>
                <div class="pv2-creation-form__textarea-wrap">
                  <textarea [(ngModel)]="editor.description" (ngModelChange)="onBasicInfoChange()"
                            [placeholder]="informativo ? 'Conte a história da loja, dê um aviso ou passe uma informação aos clientes...' : 'Descreva os ingredientes e detalhes do seu produto...'"
                            [rows]="informativo ? 8 : 3" [attr.maxlength]="descricaoMaxLength"
                            [disabled]="!podeEditarProdutos"></textarea>
                  <span class="pv2-creation-form__char-count"
                        *ngIf="(editor.description?.length || 0) >= descricaoMaxLength * 0.8"
                        [class.is-limit]="(editor.description?.length || 0) >= descricaoMaxLength">{{ (editor.description?.length || 0) }}/{{ descricaoMaxLength }}</span>
                </div>
              </label>

              <button type="button" class="pv2-creation-form__advanced-toggle" *ngIf="isNewProduct && !informativo" (click)="showAdvanced = !showAdvanced" [attr.aria-expanded]="showAdvanced">
                <i class="fa" [ngClass]="showAdvanced ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                {{ showAdvanced ? 'Menos opções' : 'Mais opções' }}
                <small *ngIf="!showAdvanced">unidade, peso, valor mínimo e visibilidade</small>
              </button>
              <ng-container *ngIf="!informativo && (!isNewProduct || showAdvanced)">
              <div class="pv2-creation-form__row--2col-equal" *ngIf="vendidoPorUnidade">
                <label class="pv2-creation-form__field">
                  <span>Qtde mínima</span>
                  <kendo-numerictextbox
                    [(ngModel)]="editor.qtdeMinima"
                    (ngModelChange)="onBasicInfoChange()"
                    [min]="0"
                    [format]="'n0'"
                    [disabled]="!podeEditarProdutos">
                  </kendo-numerictextbox>
                  <small class="pv2-field-note">Menos que isso o cliente não consegue pedir. 0 = sem mínimo.</small>
                </label>
                <label class="pv2-creation-form__field">
                  <span>Qtde máxima</span>
                  <kendo-numerictextbox
                    [(ngModel)]="editor.qtdMaxima"
                    (ngModelChange)="onBasicInfoChange()"
                    [min]="0"
                    [format]="'n0'"
                    [disabled]="!podeEditarProdutos">
                  </kendo-numerictextbox>
                  <small class="pv2-field-note">Teto por pedido, para não esvaziar o estoque de uma vez. 0 = sem teto.</small>
                </label>
              </div>

              <ng-container *ngIf="vendidoPorPeso">
                <div class="pv2-creation-form__row--2col">
                  <label class="pv2-creation-form__field">
                    <span>Incremento</span>
                    <kendo-numerictextbox
                      [(ngModel)]="editor.incremento"
                      (ngModelChange)="onBasicInfoChange()"
                      [min]="1"
                      [format]="'n0'"
                      [disabled]="!podeEditarProdutos">
                    </kendo-numerictextbox>
                    <small class="pv2-field-note">Quanto o + e o - andam de cada vez, na unidade de medida abaixo.</small>
                  </label>
                  <label class="pv2-creation-form__field">
                    <span>Unidade de medida</span>
                    <kendo-dropdownlist
                      [data]="unidades"
                      [textField]="'descricao'"
                      [(ngModel)]="editor.unidadeMedida"
                      (ngModelChange)="onBasicInfoChange()"
                      [defaultItem]="{ descricao: 'Selecione' }"
                      [disabled]="!podeEditarProdutos">
                    </kendo-dropdownlist>
                  </label>
                </div>
                <div class="pv2-creation-form__row--3col">
                  <label class="pv2-creation-form__field">
                    <span>Valor inicial</span>
                    <kendo-numerictextbox
                      [(ngModel)]="editor.valorInicial"
                      (ngModelChange)="onBasicInfoChange()"
                      [min]="0"
                      [format]="'n2'"
                      [step]="0.01"
                      [disabled]="!podeEditarProdutos">
                    </kendo-numerictextbox>
                    <small class="pv2-field-note">Peso que já vem escolhido quando o cliente abre o produto.</small>
                  </label>
                  <label class="pv2-creation-form__field">
                    <span>Peso mínimo</span>
                    <kendo-numerictextbox
                      [(ngModel)]="editor.pesoMinimo"
                      (ngModelChange)="onBasicInfoChange()"
                      [min]="0"
                      [format]="'n2'"
                      [step]="0.01"
                      [disabled]="!podeEditarProdutos">
                    </kendo-numerictextbox>
                    <small class="pv2-field-note">Menos que isso o cliente não consegue pedir.</small>
                  </label>
                  <label class="pv2-creation-form__field">
                    <span>Peso máximo</span>
                    <kendo-numerictextbox
                      [(ngModel)]="editor.pesoMaximo"
                      (ngModelChange)="onBasicInfoChange()"
                      [min]="0"
                      [format]="'n2'"
                      [step]="0.01"
                      [disabled]="!podeEditarProdutos">
                    </kendo-numerictextbox>
                  </label>
                </div>
              </ng-container>

              <div class="pv2-minimo-venda" *ngIf="!informativo" [class.pv2-minimo-venda--ativo]="editor.valorMinimoVenda > 0">
                <div class="pv2-minimo-venda__texto">
                  <span>Valor mínimo do produto
                    <em *ngIf="editor.valorMinimoVenda > 0">ativo</em>
                  </span>
                  <small>Na loja, o produto só pode ser adicionado quando a soma dele com os adicionais
                    atingir esse valor. Deixe vazio para não exigir mínimo.</small>
                </div>
                <div class="pv2-minimo-venda__campo">
                  <kendo-numerictextbox
                    [(ngModel)]="editor.valorMinimoVenda"
                    (ngModelChange)="onBasicInfoChange()"
                    [min]="0"
                    [format]="'$0.00'"
                    [step]="1"
                    [disabled]="!podeEditarProdutos">
                  </kendo-numerictextbox>
                </div>
              </div>

              <div class="pv2-creation-form__toggles" *ngIf="!informativo">
                <div class="pv2-toggle-row" [class.is-disabled]="!precoPermiteBrinde">
                  <div class="pv2-toggle-row__label">
                    <span>É brinde</span>
                    <small *ngIf="precoPermiteBrinde">O cliente ganha o item; ele não entra na soma do pedido.</small>
                    <small *ngIf="!precoPermiteBrinde && !brindeDesligadoPeloPreco">Só vale para produto com preço zero.</small>
                    <small class="is-warning" *ngIf="brindeDesligadoPeloPreco">
                      Desligado porque o produto passou a ter preço. Zere o preço para marcar como brinde.
                    </small>
                  </div>
                  <kendo-switch
                    [(ngModel)]="editor.ehBrinde"
                    (ngModelChange)="onBasicInfoChange()"
                    [disabled]="!podeEditarProdutos || !precoPermiteBrinde">
                  </kendo-switch>
                </div>
                <div class="pv2-toggle-row">
                  <div class="pv2-toggle-row__label">
                    <span>Não aplicar cupom</span>
                    <small>Cupons de desconto passam a ignorar este produto no carrinho.</small>
                  </div>
                  <kendo-switch
                    [(ngModel)]="editor.naoAceitaCupom"
                    (ngModelChange)="onBasicInfoChange()"
                    [disabled]="!podeEditarProdutos">
                  </kendo-switch>
                </div>
                <div class="pv2-toggle-row" *ngIf="catalogoCompartilhado">
                  <div class="pv2-toggle-row__label">
                    <span>Sincronizar catálogos</span>
                    <small>Alterações neste produto passam a valer nas outras lojas que usam este catálogo.</small>
                  </div>
                  <kendo-switch
                    [(ngModel)]="editor.sincronizarModelos"
                    (ngModelChange)="onBasicInfoChange()"
                    [disabled]="!podeEditarProdutos">
                  </kendo-switch>
                </div>
              </div>
              </ng-container>
            </div>
          </div>

          <div class="pv2-creation-form__actions" *ngIf="isNewProduct">
            <span class="pv2-creation-form__actions-hint" *ngIf="hasCreationErrors" role="alert">
              <span class="fa fa-exclamation-circle"></span> Corrija os campos destacados para criar o produto.
            </span>
            <button type="button" class="pv2-ghost-btn" (click)="goBack()">Cancelar</button>
            <button type="button" class="pv2-secondary-btn pv2-creation-form__save-new-btn" (click)="saveNewProduct('new')"
                    [disabled]="!podeEditarProdutos" title="Cria este produto e abre outro formulário na mesma categoria">
              <i class="fa fa-plus"></i>
              Salvar e novo
            </button>
            <button type="button" class="pv2-primary-btn pv2-creation-form__save-btn" (click)="saveNewProduct()"
                    [disabled]="!podeEditarProdutos" title="Cria o produto e abre fotos, adicionais e demais configurações">
              Salvar e configurar
            </button>
          </div>
        </section>

        <!-- Seção de Fotos do Produto -->
        <section class="pv2-photos-section" *ngIf="activeProductTab === 'photos' && !isNewProduct && editor.raw">
          <div class="pv2-photos-section__header">
            <h2 class="pv2-photos-section__title">
              <span class="fa fa-camera"></span>
              Fotos do produto
            </h2>
            <p class="pv2-photos-section__subtitle">Cada foto adicionada ou removida é salva na hora.</p>
          </div>
          <div class="pv2-photos-section__gallery"
               [style.pointer-events]="podeEditarProdutos ? null : 'none'"
               [style.opacity]="podeEditarProdutos ? null : '0.55'">
            <app-upload-multiplas-imagens
              [objeto]="editor.raw"
              [sm]="true"
              [maxsize]="800"
              [autoSalvar]="true"
              prop="imagens"
              (onSalvar)="salveImagensProduto($event)">
            </app-upload-multiplas-imagens>
          </div>
        </section>

        <!-- Upload de foto para produto novo -->
        <section class="pv2-photos-section pv2-photos-section--new" *ngIf="activeProductTab === 'photos' && isNewProduct">
          <div class="pv2-photos-section__header">
            <h2 class="pv2-photos-section__title">
              <span class="fa fa-camera"></span>
              Foto do produto
            </h2>
            <p class="pv2-photos-section__subtitle">Adicione uma foto para o produto (opcional)</p>
          </div>
          <div class="pv2-photos-section__dropzone"
               (click)="creationFileInput.click()"
               [class.has-preview]="creationImagePreview"
               [style.pointer-events]="podeEditarProdutos ? null : 'none'"
               [style.opacity]="podeEditarProdutos ? null : '0.55'">
            <img *ngIf="creationImagePreview" [src]="creationImagePreview" alt="Prévia da foto do produto">
            <ng-container *ngIf="!creationImagePreview">
              <span class="fa fa-image pv2-photos-section__dropzone-icon"></span>
              <span class="pv2-photos-section__dropzone-label">Adicionar foto</span>
              <span class="pv2-photos-section__dropzone-hint">JPG ou PNG até 5MB</span>
            </ng-container>
          </div>
          <input #creationFileInput type="file" accept=".jpg,.jpeg,.png"
                 (change)="onCreationImageSelected($event)" hidden
                 [disabled]="!podeEditarProdutos">
        </section>

        <ng-container *ngIf="!isNewProduct">
        <section class="pv2-pricing-grid" *ngIf="activeProductTab === 'pricing'">
        <div class="pv2-pricing-grid__main">
        <article class="pv2-preco-card" *ngIf="!possuiPrecoCanalDiferenciado && !temModuloTabelaPrecos && editor.type !== 'pizza'">
          <div class="pv2-preco-card__campo">
            <label class="pv2-creation-form__field">
              <span>Preço do produto</span>
              <kendo-numerictextbox
                [(ngModel)]="editor.basePrice"
                (ngModelChange)="onBasicInfoChange()"
                [min]="0"
                [format]="'$0.00'"
                [step]="0.5"
                [disabled]="!podeEditarPrecos">
              </kendo-numerictextbox>
              <small class="pv2-field-note">É o mesmo preço do Básico, aqui ao lado da promoção que trabalha em cima dele.</small>
            </label>
          </div>
          <p class="pv2-preco-card__nota">Preço cheio do produto. A promoção abaixo é calculada em cima dele.</p>
        </article>

        <app-precos-canais-produto
          id="pv2-precos-canais-section"
          [produtoId]="editor.id" [podeEditar]="podeEditarPrecos" [produtoAtualizado]="editor"
          [empresa]="empresa" [produto]="editor.raw" [temModuloTabelaPrecos]="temModuloTabelaPrecos"
          [tabelaPrecosTargetKey]="tabelaPrecosTargetKey"
          [precoCardapio]="precoCheio" [descontoCardapio]="descontoCardapioCanais"
          [promocaoCardapioAtiva]="editor.promotion.exibirDescontos"
          [disponivelCardapio]="editor.availability.disponibilidadeTipo !== 2 && editor.availability.delivery"
          [editarMeuCardapio]="!temModuloTabelaPrecos"
          (precoCardapioChange)="alterePrecoCardapio($event)"
          (descontoCardapioChange)="altereDescontoCardapio($event)"
          (promocaoCardapioAtivaChange)="$event ? inserirDesconto() : removerDesconto()"
          (possuiPrecoDiferenciadoChange)="possuiPrecoCanalDiferenciado = $event">
        </app-precos-canais-produto>

        <section class="pv2-promo-section">
          <article class="pv2-promo-bar" *ngIf="!possuiPrecoCanalDiferenciado && !temModuloTabelaPrecos && editor.type !== 'pizza'"
            [class.pv2-promo-bar--active]="editor.promotion.exibirDescontos">
            <div class="pv2-promo-bar__row">
              <div class="pv2-promo-bar__left">
                <h4>Promoção</h4>
                <p>Preço riscado e selo de desconto no cardápio. Funciona em cima do preço do produto.</p>
              </div>
              <div class="pv2-promo-bar__right">
                <label class="pv2-switch">
                  <input type="checkbox" [ngModel]="editor.promotion.exibirDescontos"
                    (ngModelChange)="$event ? inserirDesconto() : removerDesconto()"
                    [disabled]="!podeEditarPrecos">
                  <span class="pv2-switch-slider"></span>
                </label>
              </div>
            </div>
            <div class="pv2-promo-bar__body" *ngIf="editor.promotion.exibirDescontos">
              <ng-container *ngIf="!precoPorEmpresa">
                <div class="pv2-promo-inputs">
                  <label class="pv2-form-field">
                    <span>Novo preço (R$)</span>
                    <input
                      [(ngModel)]="editor.promotion.novoPreco"
                      (ngModelChange)="alterouNovoPreco()"
                      type="number" step="0.01" min="0" inputmode="decimal"
                      placeholder="0,00"
                      [disabled]="!podeEditarPrecos">
                  </label>
                  <div class="pv2-promo-link-icon" aria-hidden="true">
                    <span class="fas fa-exchange-alt"></span>
                  </div>
                  <label class="pv2-form-field">
                    <span>Desconto (%)</span>
                    <input
                      [(ngModel)]="editor.promotion.percentualDesconto"
                      (ngModelChange)="alterouPercentualDesconto()"
                      type="number" step="0.01" min="0" max="100" inputmode="decimal"
                      placeholder="0"
                      [disabled]="!podeEditarPrecos">
                  </label>
                  <button type="button" class="pv2-promo-clear-link" (click)="removerDesconto()"
                    [disabled]="!podeEditarPrecos">Limpar</button>
                </div>
              </ng-container>

              <ng-container *ngIf="precoPorEmpresa">
                <div class="pv2-promo-inputs">
                  <label class="pv2-form-field">
                    <span>Novo preço empresa (R$)</span>
                    <input
                      [(ngModel)]="editor.promotion.novoPrecoNaEmpresa"
                      (ngModelChange)="alterouNovoPrecoNaEmpresa()"
                      type="number" step="0.01" min="0" inputmode="decimal"
                      placeholder="0,00"
                      [disabled]="!podeEditarPrecos">
                  </label>
                  <div class="pv2-promo-link-icon" aria-hidden="true">
                    <span class="fas fa-exchange-alt"></span>
                  </div>
                  <label class="pv2-form-field">
                    <span>Desconto empresa (%)</span>
                    <input [(ngModel)]="editor.promotion.percentualDescontoNaEmpresa"
                      (ngModelChange)="alterouPercentualDescontoNaEmpresa()"
                      type="number" step="0.01" min="0" max="100" inputmode="decimal"
                      placeholder="0"
                      [disabled]="!podeEditarPrecos">
                  </label>
                  <button type="button" class="pv2-promo-clear-link" (click)="removerDesconto()"
                    [disabled]="!podeEditarPrecos">Limpar</button>
                </div>
              </ng-container>

              <div class="pv2-promo-resultado" [class.pv2-promo-resultado--valido]="temPromocaoValida">
                <ng-container *ngIf="temPromocaoValida; else promoIncompleta">
                  <span class="pv2-promo-resultado__label">No cardápio</span>
                  <span class="pv2-promo-resultado__old">R$ {{ precoCheio | number:'1.2-2':'pt' }}</span>
                  <span class="pv2-promo-resultado__new">R$ {{ precoPromocional | number:'1.2-2':'pt' }}</span>
                  <span class="pv2-promo-badge">{{ descontoPercentual }}% OFF</span>
                </ng-container>
                <ng-template #promoIncompleta>
                  <span class="pv2-promo-resultado__label">Informe um preço menor que R$ {{ precoCheio | number:'1.2-2':'pt' }} para a promoção aparecer.</span>
                </ng-template>
              </div>
            </div>
          </article>

          <article class="pv2-destaque-card">
            <div class="pv2-destaque-card__head">
              <div>
                <h4>Destaque</h4>
                <p>Abre uma vitrine no topo do cardápio, antes das categorias. Serve para o
                  que você quer vender primeiro — o carro-chefe, a novidade da semana.</p>
              </div>
              <label class="pv2-switch">
                <input type="checkbox" [(ngModel)]="editor.classification.destaque" (ngModelChange)="onClassificationChange()"
                       [disabled]="!podeEditarProdutos">
                <span class="pv2-switch-slider"></span>
              </label>
            </div>
            <p class="pv2-destaque-card__nota" *ngIf="editor.classification.destaque">
              Sai da vitrine se o produto ficar indisponível.
            </p>
          </article>
        </section>

        </div>

        <aside class="pv2-pricing-grid__preview">
          <span class="pv2-preview-eyebrow">Visão do cliente</span>

          <div class="pv2-preview-shell">
            <div class="pv2-vitrine" *ngIf="editor.classification.destaque">
              <div class="pv2-vitrine__head">
                <strong>Destaques</strong>
                <span>ver todos</span>
              </div>
              <div class="pv2-vitrine__trilho">
                <ng-container *ngTemplateOutlet="cartaoClienteTpl; context: { compacto: true }"></ng-container>
                <div class="pv2-vitrine__fantasma" aria-hidden="true"></div>
              </div>
            </div>

            <div class="pv2-vitrine-lista">
              <span class="pv2-vitrine-lista__titulo">{{ editor.category || 'Categoria' }}</span>
              <ng-container *ngTemplateOutlet="cartaoClienteTpl; context: { compacto: false }"></ng-container>
            </div>
          </div>

          <p class="pv2-preview-legenda" *ngIf="!editor.classification.destaque">
            Com o destaque ligado, o produto ganha uma vitrine acima das categorias — e continua
            aparecendo na categoria dele.
          </p>
        </aside>

        <ng-template #cartaoClienteTpl let-compacto="compacto">
          <article class="pv2-cliente-card" [class.is-compacto]="compacto">
            <div class="pv2-cliente-card__foto" [class.has-image]="hasEditorImage()">
              <img [hidden]="!hasEditorImage()" [src]="editor.image" [alt]="editor.name" (error)="onEditorImageError()">
              <span [hidden]="hasEditorImage()">{{ getEditorPlaceholder() }}</span>
            </div>
            <div class="pv2-cliente-card__texto">
              <h5>{{ editor.name || 'Nome do produto' }}</h5>
              <p *ngIf="!compacto && editor.description">{{ editor.description }}</p>
              <div class="pv2-cliente-card__precos">
                <ng-container *ngIf="temPromocaoValida; else semPromocaoTpl">
                  <s>R$ {{ precoCheio | number:'1.2-2':'pt' }}</s>
                  <strong>R$ {{ precoPromocional | number:'1.2-2':'pt' }}</strong>
                  <span class="pv2-cliente-card__off">{{ descontoPercentual | number:'1.0-0' }}% OFF</span>
                </ng-container>
                <ng-template #semPromocaoTpl>
                  <strong>R$ {{ precoCheio | number:'1.2-2':'pt' }}</strong>
                </ng-template>
              </div>
            </div>
          </article>
        </ng-template>
        </section>

        <section id="pv2-tabela-precos-section" class="pv2-price-table-section" *ngIf="activeProductTab === 'pricing' && temModuloTabelaPrecos && editor.id && !possuiPrecoCanalDiferenciado">
          <article class="pv2-side-card pv2-price-table-card">
            <header (click)="sectionTabelaPrecosOpen = !sectionTabelaPrecosOpen">
              <div>
                <h4>Tabela preços</h4>
                <p>Preços por tabela ativa</p>
              </div>
              <span class="fa" [ngClass]="sectionTabelaPrecosOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
            </header>

            <div class="pv2-side-body" *ngIf="sectionTabelaPrecosOpen">
              <app-produto-tabela-precos
                [empresa]="empresa"
                [produto]="editor.raw"
                [produtoId]="editor.id"
                [targetSelecionadoKeyPreferencial]="tabelaPrecosTargetKey"
                [podeEditarPrecos]="podeEditarPrecos">
              </app-produto-tabela-precos>
            </div>
          </article>
        </section>

        <section class="pv2-price-table-section" *ngIf="activeProductTab === 'fiscal' && temModuloComissionamento && editor.id">
          <article class="pv2-side-card pv2-price-table-card">
            <header (click)="sectionComissionamentoOpen = !sectionComissionamentoOpen">
              <div>
                <h4>Comissões</h4>
                <p>Comissão fixa por produto produzido</p>
              </div>
              <span class="fa" [ngClass]="sectionComissionamentoOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
            </header>

            <div class="pv2-side-body" *ngIf="sectionComissionamentoOpen">
              <label class="pv2-field">
                <span>Comissão vinculada</span>
                <select [(ngModel)]="editor.raw.comissao" (ngModelChange)="onComissaoChange()" [compareWith]="compareComissao" [disabled]="!podeEditarProdutos">
                  <option [ngValue]="null">Sem comissão</option>
                  <option *ngFor="let comissao of comissoes" [ngValue]="comissao">
                    {{comissao.nome}} - {{comissao.valorFixo | currency:'BRL'}}
                  </option>
                </select>
              </label>

              <p class="pv2-field-hint" *ngIf="editor.raw.comissao?.id && comissaoSelecionada()?.ativo">
                {{comissaoSelecionada()?.nome}} por {{comissaoSelecionada()?.valorFixo | currency:'BRL'}} por unidade.
              </p>
              <p class="pv2-field-hint" *ngIf="editor.raw.comissao?.id && !comissaoSelecionada()?.ativo">
                Comissão inativa: este produto não exigirá comissionado em novos pedidos.
              </p>
            </div>
          </article>
        </section>

        <ng-container *ngIf="activeProductTab === 'adicionais'">
        <section class="pv2-groups-header">
          <div class="pv2-groups-header__title">
            <h3>Adicionais</h3>
            <span>{{ editor.groups.length }}</span>
          </div>

          <div class="pv2-groups-actions">
            <button type="button" class="pv2-secondary-btn pv2-manage-additionals-btn"
                    kendoTooltip
                    title="Abre o catálogo de adicionais da loja, fora deste produto. O botão de voltar de lá traz você de volta para cá."
                    (click)="openAdditionalCatalog()">
              Catálogo de adicionais
              <i class="fa fa-external-link pv2-manage-additionals-btn__icon" aria-hidden="true"></i>
            </button>
            <button type="button" class="pv2-secondary-btn" *ngIf="editor.groups.length > 0" (click)="openReorderSheet()"
                    [disabled]="!podeEditarEstruturaAdicional || editor.groups.length < 2">
              <i class="fa fa-sort"></i>
              Reordenar
            </button>
            <button type="button" class="pv2-primary-btn" (click)="openGroupPanel()"
                    [disabled]="!podeEditarProdutos">
              <i class="fa fa-plus"></i>
              Novo
            </button>
          </div>
        </section>

        <section class="pv2-groups-grid" *ngIf="editor.groups.length > 0; else emptyGroupsTpl">
          <article
            class="pv2-group-card"
            *ngFor="let group of editor.groups; trackBy: trackByGroup"
            [class.is-shared]="group.shared"
            [class.is-required]="group.required"
            [class.is-overview-card]="embedded"
            [class.has-dense-summary]="shouldUseDenseGroupSummary(group)"
            [class.has-many-options]="isMobile && group.options.length >= 8"
            (click)="onGroupCardPressed(group)">
            <header class="pv2-group-top">
              <div class="pv2-group-type-badge" [ngClass]="{
                'is-required': group.required,
                'is-single': group.type === 'single',
                'is-multi': group.type === 'multiple',
                'is-repeat': group.type === 'multipleRepeat'
              }">
                <i class="fa" [ngClass]="{
                  'fa-dot-circle': group.type === 'single',
                  'fa-plus-circle': group.type === 'multiple',
                  'fa-clone': group.type === 'multipleRepeat'
                }"></i>
              </div>
              <div class="pv2-group-title">
                <div>
                  <div class="pv2-group-name-row">
                    <h4>{{ group.name }}</h4>
                    <span class="pv2-required-badge" [class.is-optional]="!group.required">{{ group.required ? 'OBRIGATÓRIO' : 'OPCIONAL' }}</span>
                    <span class="pv2-shared-badge" *ngIf="group.shared">
                      <i class="fa fa-link"></i> Compartilhado
                    </span>
                  </div>
                  <p>{{ getGroupRuleSummary(group) }}</p>
                </div>
              </div>

              <div class="pv2-group-top-actions">
                <span class="fa fa-chevron-right pv2-group-chevron"></span>
              </div>
            </header>

            <div class="pv2-group-snippet" *ngIf="embedded || !isExpanded(group)">
              <span class="pv2-group-snippet__chip" *ngFor="let name of getGroupOptionNames(group)">{{ name }}</span>
              <span class="pv2-group-snippet__chip is-count" *ngIf="getGroupOptionRemainingCount(group) > 0">+{{ getGroupOptionRemainingCount(group) }} opções</span>
            </div>

            <div class="pv2-group-rules-bar" *ngIf="canEditGroupStructure(group) && (embedded || !isExpanded(group)) && !shouldUseDenseGroupSummary(group)">
              <span><i class="fa fa-circle"></i> {{ group.type === 'single' ? 'Única' : group.type === 'multipleRepeat' ? 'Múltipla c/ rep.' : 'Múltipla' }}</span>
              <span [class.is-highlight]="group.required" [class.is-optional]="!group.required"><i class="fa fa-lock"></i> {{ group.required ? 'Obrigatório' : 'Opcional' }}</span>
              <span><i class="fa fa-th"></i> {{ group.chargeType | titlecase }}</span>
              <span><i class="fa fa-list-ul"></i> {{ getGroupAvailableOptionLabel(group) }}</span>
            </div>

            <footer class="pv2-group-share-info" *ngIf="!embedded && group.shared">
              <span class="fa fa-link"></span>
              Vinculado a {{ group.sharedCount }} produtos
            </footer>

            <section class="pv2-dense-group-summary" *ngIf="shouldUseDenseGroupSummary(group)">
              <div class="pv2-dense-group-summary__stats">
                <span class="pv2-dense-group-summary__stat">{{ group.options.length }} opções</span>
                <span class="pv2-dense-group-summary__stat is-active">{{ getGroupActiveOptionCount(group) }} ativas</span>
                <span class="pv2-dense-group-summary__stat" *ngIf="getGroupInactiveOptionCount(group) > 0">{{ getGroupInactiveOptionCount(group) }} pausadas</span>
              </div>

              <p class="pv2-dense-group-summary__preview">{{ getGroupOptionPreview(group) }}<span *ngIf="getGroupOptionRemainingCount(group) > 0">, +{{ getGroupOptionRemainingCount(group) }} opções</span></p>

            </section>

            <ng-container *ngIf="!embedded && isExpanded(group) && !shouldUseDenseGroupSummary(group) && isFixedGroup(group)">
              <button type="button" class="pv2-group-rules" *ngIf="canEditGroupStructure(group)" (click)="openGroupPanel(group)">
                <div class="pv2-rule-grid">
                  <div class="pv2-rule-item">
                    <span class="pv2-rule-label"><i class="fa fa-dot-circle"></i> Tipo</span>
                    <span class="pv2-rule-value">{{ group.type === 'single' ? 'Única' : group.type === 'multipleRepeat' ? 'Múltipla c/ rep.' : 'Múltipla' }}</span>
                  </div>
                  <div class="pv2-rule-item">
                    <span class="pv2-rule-label"><i class="fa fa-lock"></i> Obrigatório</span>
                    <span class="pv2-rule-value" [class.is-required]="group.required">{{ group.required ? 'Sim' : 'Não' }}</span>
                  </div>
                  <div class="pv2-rule-item" *ngIf="group.type !== 'single'">
                    <span class="pv2-rule-label"><i class="fa fa-sliders-h"></i> Quantidade</span>
                    <span class="pv2-rule-value">{{ group.min }}–{{ group.max }}</span>
                  </div>
                  <div class="pv2-rule-item">
                    <span class="pv2-rule-label"><i class="fa fa-calculator"></i> Cobrança</span>
                    <span class="pv2-rule-value">{{ group.chargeType | titlecase }}</span>
                  </div>
                </div>
                <span class="pv2-rule-edit"><i class="fa fa-pencil"></i> Editar regras</span>
              </button>

              <div class="pv2-group-rules-bar" *ngIf="!canEditGroupStructure(group)">
                <span><i class="fa fa-lock"></i> Estrutura fixa</span>
                <span><i class="fa fa-pizza-slice"></i> Tamanhos e preços</span>
              </div>

              <div class="pv2-group-warning" *ngIf="group.shared">
                <span class="fa fa-link"></span>
                Compartilhado em {{ group.sharedCount }} produtos — permissões seguem o catálogo compartilhado
              </div>

              <div class="pv2-options-shell" [class.has-many-options]="isMobile && group.options.length >= 8">
                <div class="pv2-options-head">
                  <span>Opções ({{ group.options.length }})</span>
                  <span *ngIf="!temModuloTabelaPrecos || group.kind === 'pizza-sizes'">{{ temModuloTabelaPrecos ? 'Preços' : 'Preço' }}</span>
                </div>

                <div class="pv2-options-scroll" [class.has-many-options]="isMobile && group.options.length >= 8">
                  <div class="pv2-option-row" *ngFor="let option of group.options; trackBy: trackByOption; let optionIndex = index" [attr.data-index]="optionIndex + 1">
                    <label class="pv2-option-active">
                      <input type="checkbox" class="k-checkbox" kendoCheckBox [(ngModel)]="option.active" (ngModelChange)="onOptionChanged(group, option, 'availability')"
                             [disabled]="!podeEditarDisponibilidadeOpcoes">
                    </label>

                    <input
                      class="pv2-option-name"
                      [(ngModel)]="option.name"
                      (ngModelChange)="onOptionChanged(group, option, 'structure')"
                      placeholder="Nome da opção"
                      [disabled]="!podeEditarEstruturaAdicional">

                    <div class="pv2-option-price-wrap" *ngIf="!temModuloTabelaPrecos">
                      <span class="pv2-option-price-label">Preço</span>
                      <input
                        class="pv2-option-price"
                        [(ngModel)]="option.price"
                        (ngModelChange)="onOptionChanged(group, option, 'price')"
                        type="number"
                        inputmode="decimal"
                        step="0.01"
                        min="0"
                        [disabled]="!podeEditarPrecoOpcoes">
                    </div>
                    <div class="pv2-option-price-wrap" *ngIf="temModuloTabelaPrecos && group.kind === 'pizza-sizes'">
                      <span class="pv2-option-price-label">Preços</span>
                      <button type="button" class="pv2-ghost-btn pv2-ghost-btn--compact" (click)="verPrecosTabela(targetKeyTabelaPrecosTamanho(option)); $event.stopPropagation()" [disabled]="!editor.id">
                        Ver preços
                      </button>
                    </div>

                    <button type="button" class="pv2-remove-btn" *ngIf="group.kind !== 'pizza-sizes'" (click)="removeOption(group, option)"
                            [disabled]="!podeEditarEstruturaAdicional">
                      <span class="fa fa-times"></span>
                    </button>
                  </div>
                </div>
              </div>

              <div class="pv2-group-footer">
                <button type="button" class="pv2-add-option-btn" *ngIf="group.kind !== 'pizza-sizes'" (click)="addOption(group)"
                        [disabled]="!podeEditarEstruturaAdicional">
                  + Adicionar opção
                </button>
                <button type="button" class="pv2-remove-group-btn" *ngIf="group.kind !== 'pizza-sizes'" (click)="removeGroup(group)"
                        [disabled]="!podeEditarEstruturaAdicional">
                  <span class="fa fa-trash"></span>
                </button>
              </div>
            </ng-container>
          </article>
        </section>

        <ng-template #emptyGroupsTpl>
          <div class="pv2-groups-empty">
            <span class="fa fa-list-ul pv2-groups-empty__icon"></span>
            <p>Nenhum adicional adicionado.</p>
            <button type="button" class="pv2-primary-btn pv2-groups-empty__action" (click)="openGroupPanel()"
                    [disabled]="!podeEditarProdutos">
              <i class="fa fa-plus"></i>
              Novo Adicional
            </button>
          </div>
        </ng-template>

        <!-- Pizza: Massas -->
        <section class="pv2-pizza-section" *ngIf="editor.type === 'pizza' && editor.pizzaMassa">
          <article class="pv2-side-card pv2-side-card--pizza">
            <header (click)="sectionMassaOpen = !sectionMassaOpen">
              <div class="pv2-pizza-section-header">
                <span class="pv2-pizza-section-icon fa fa-circle-o"></span>
                <h4>Massas</h4>
                <span class="pv2-pizza-section-count">{{ editor.pizzaMassa.options.length }}</span>
              </div>
              <span class="fa" [ngClass]="sectionMassaOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
            </header>
            <div class="pv2-side-body" *ngIf="sectionMassaOpen">
              <div class="pv2-pizza-table">
                <div class="pv2-pizza-table__head">
                  <span>Nome</span>
                  <span *ngIf="!temModuloTabelaPrecos">Preço</span>
                  <span>Cod. PDV</span>
                  <span>Tamanho</span>
                  <span>Disponível</span>
                </div>
                <div class="pv2-pizza-table__row"
                     *ngFor="let opt of editor.pizzaMassa.options"
                     [class.is-inactive]="!opt.active">
                  <span class="pv2-pizza-table__name">{{ opt.name }}</span>
                  <span class="pv2-pizza-table__price" *ngIf="!temModuloTabelaPrecos">R$ {{ opt.price | number:'1.2-2' }}</span>
                  <span class="pv2-pizza-table__pdv">{{ opt.codigoPdv || '–' }}</span>
                  <span class="pv2-pizza-table__size">{{ opt.sizeName || 'Todos' }}</span>
                  <label class="pv2-switch">
                    <input type="checkbox" [(ngModel)]="opt.active"
                           (ngModelChange)="onPizzaOptionChanged(editor.pizzaMassa)"
                           [disabled]="!podeEditarDisponibilidadeOpcoes">
                    <span class="pv2-switch-slider"></span>
                  </label>
                </div>
              </div>
              <div class="pv2-pizza-section-footer" *ngIf="editor.pizzaMassa.dirty || editor.pizzaMassa.saving">
                <button type="button" class="pv2-primary-btn"
                        (click)="savePizzaAdicional(editor.pizzaMassa)"
                        [disabled]="editor.pizzaMassa.saving || !podeEditarAlgumaOpcao">
                  {{ editor.pizzaMassa.saving ? 'Salvando...' : 'Salvar Massas' }}
                </button>
              </div>
            </div>
          </article>
        </section>

        <!-- Pizza: Bordas -->
        <section class="pv2-pizza-section" *ngIf="editor.type === 'pizza' && editor.pizzaBorda">
          <article class="pv2-side-card pv2-side-card--pizza">
            <header (click)="sectionBordaOpen = !sectionBordaOpen">
              <div class="pv2-pizza-section-header">
                <span class="pv2-pizza-section-icon fa fa-dot-circle-o"></span>
                <h4>Bordas</h4>
                <span class="pv2-pizza-section-count">{{ editor.pizzaBorda.options.length }}</span>
              </div>
              <span class="fa" [ngClass]="sectionBordaOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
            </header>
            <div class="pv2-side-body" *ngIf="sectionBordaOpen">
              <div class="pv2-pizza-table">
                <div class="pv2-pizza-table__head">
                  <span>Nome</span>
                  <span *ngIf="!temModuloTabelaPrecos">Preço</span>
                  <span>Cod. PDV</span>
                  <span>Tamanho</span>
                  <span>Disponível</span>
                </div>
                <div class="pv2-pizza-table__row"
                     *ngFor="let opt of editor.pizzaBorda.options"
                     [class.is-inactive]="!opt.active">
                  <span class="pv2-pizza-table__name">{{ opt.name }}</span>
                  <span class="pv2-pizza-table__price" *ngIf="!temModuloTabelaPrecos">R$ {{ opt.price | number:'1.2-2' }}</span>
                  <span class="pv2-pizza-table__pdv">{{ opt.codigoPdv || '–' }}</span>
                  <span class="pv2-pizza-table__size">{{ opt.sizeName || 'Todos' }}</span>
                  <label class="pv2-switch">
                    <input type="checkbox" [(ngModel)]="opt.active"
                           (ngModelChange)="onPizzaOptionChanged(editor.pizzaBorda)"
                           [disabled]="!podeEditarDisponibilidadeOpcoes">
                    <span class="pv2-switch-slider"></span>
                  </label>
                </div>
              </div>
              <div class="pv2-pizza-section-footer" *ngIf="editor.pizzaBorda.dirty || editor.pizzaBorda.saving">
                <button type="button" class="pv2-primary-btn"
                        (click)="savePizzaAdicional(editor.pizzaBorda)"
                        [disabled]="editor.pizzaBorda.saving || !podeEditarAlgumaOpcao">
                  {{ editor.pizzaBorda.saving ? 'Salvando...' : 'Salvar Bordas' }}
                </button>
              </div>
            </div>
          </article>
        </section>
        </ng-container>

        <section class="pv2-secondary-grid" *ngIf="activeProductTab === 'availability' || activeProductTab === 'fiscal'">
          <article class="pv2-side-card" *ngIf="activeProductTab === 'availability'">
            <header (click)="sectionAvailabilityOpen = !sectionAvailabilityOpen">
              <h4>Disponibilidade</h4>
              <span class="fa" [ngClass]="sectionAvailabilityOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
            </header>
            <div class="pv2-side-body" *ngIf="sectionAvailabilityOpen">
              <div class="pv2-radio-group">
                <label class="pv2-radio-option" [class.pv2-radio-option--selected]="editor.availability.disponibilidadeTipo === 0">
                  <input kendoRadioButton type="radio" name="disponibilidadeTipo" [value]="0" [(ngModel)]="editor.availability.disponibilidadeTipo" (ngModelChange)="onDisponibilidadeTipoChange()"
                         [disabled]="!podeEditarProdutos">
                  <span>Sempre disponível</span>
                </label>
                <label class="pv2-radio-option" [class.pv2-radio-option--selected]="editor.availability.disponibilidadeTipo === 1">
                  <input kendoRadioButton type="radio" name="disponibilidadeTipo" [value]="1" [(ngModel)]="editor.availability.disponibilidadeTipo" (ngModelChange)="onDisponibilidadeTipoChange()"
                         [disabled]="!podeEditarProdutos">
                  <span>Disponível em dias específicos</span>
                </label>
                <label class="pv2-radio-option" [class.pv2-radio-option--selected]="editor.availability.disponibilidadeTipo === 2">
                  <input kendoRadioButton type="radio" name="disponibilidadeTipo" [value]="2" [(ngModel)]="editor.availability.disponibilidadeTipo" (ngModelChange)="onDisponibilidadeTipoChange()"
                         [disabled]="!podeEditarProdutos">
                  <span>Não disponível</span>
                </label>
              </div>

              <div class="pv2-availability-schedule" *ngIf="editor.availability.disponibilidadeTipo === 1"
                   [style.pointer-events]="podeEditarProdutos ? null : 'none'"
                   [style.opacity]="podeEditarProdutos ? null : '0.55'">
                <app-view-disponibilidade [disponibilidades]="editor.raw.disponibilidades" [catalogo]="empresa?.catalogo"
                                         (disponibilidadesChange)="onDisponibilidadesChange($event)"></app-view-disponibilidade>
                <small class="text-muted" *ngIf="!editor.raw.disponibilidades?.length">Selecione pelo menos uma disponibilidade para salvar.</small>
              </div>

              <h5 class="pv2-subsection-title">Onde exibir</h5>

              <div class="pv2-toggle-row">
                <span>Delivery</span>
                <label class="pv2-switch">
                  <input type="checkbox" [(ngModel)]="editor.availability.delivery" (ngModelChange)="onAvailabilityChange()"
                         [disabled]="!podeEditarProdutos">
                  <span class="pv2-switch-slider"></span>
                </label>
              </div>
              <div class="pv2-toggle-row">
                <span>Mesa / Balcão</span>
                <label class="pv2-switch">
                  <input type="checkbox" [(ngModel)]="editor.availability.balcao" (ngModelChange)="onAvailabilityChange()"
                         [disabled]="!podeEditarProdutos">
                  <span class="pv2-switch-slider"></span>
                </label>
              </div>

              <ng-container *ngIf="showExibirNoSite">
                <div class="pv2-toggle-row">
                  <span>Exibir no site</span>
                  <label class="pv2-switch">
                    <input type="checkbox" [(ngModel)]="editor.availability.exibirNoSite" (ngModelChange)="onAvailabilityChange()"
                           [disabled]="!podeEditarProdutos">
                    <span class="pv2-switch-slider"></span>
                  </label>
                </div>
                <ng-container *ngIf="editor.availability.exibirNoSite">
                  <div class="pv2-toggle-row">
                    <span>Exibir preço no site</span>
                    <label class="pv2-switch">
                      <input type="checkbox" [(ngModel)]="editor.availability.exibirPrecoSite" (ngModelChange)="onAvailabilityChange()"
                             [disabled]="!podeEditarProdutos">
                      <span class="pv2-switch-slider"></span>
                    </label>
                  </div>
                  <label class="pv2-form-field">
                    <span>Mensagem do pedido</span>
                    <input [(ngModel)]="editor.availability.mensagemPedido" (ngModelChange)="onAvailabilityChange()" type="text" placeholder="Mensagem do Pedido"
                           [disabled]="!podeEditarProdutos">
                  </label>
                </ng-container>
              </ng-container>

              <div class="pv2-toggle-row">
                <span>Exibir preço no cardápio</span>
                <label class="pv2-switch">
                  <input type="checkbox" [(ngModel)]="editor.availability.exibirPrecoNoCardapio" (ngModelChange)="onAvailabilityChange()"
                         [disabled]="!podeEditarProdutos">
                  <span class="pv2-switch-slider"></span>
                </label>
              </div>
              <p class="pv2-field-hint" *ngIf="!editor.availability.exibirPrecoNoCardapio">Atenção: o preço continuará sendo exibido ao selecionar o produto no cardápio</p>

              <div class="pv2-toggle-row" *ngIf="showNaoSincronizar">
                <span>Não sincronizar com catálogo da rede</span>
                <label class="pv2-switch">
                  <input type="checkbox" [(ngModel)]="editor.availability.naoSincronizar" (ngModelChange)="onAvailabilityChange()"
                         [disabled]="!podeEditarProdutos">
                  <span class="pv2-switch-slider"></span>
                </label>
              </div>
            </div>
          </article>

          <article class="pv2-side-card" *ngIf="activeProductTab === 'availability'">
            <header (click)="sectionClassificationOpen = !sectionClassificationOpen">
              <h4>Classificação</h4>
              <span class="fa" [ngClass]="sectionClassificationOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
            </header>
            <div class="pv2-side-body" *ngIf="sectionClassificationOpen">

              <div class="pv2-tag-cloud">
                <button
                  type="button"
                  class="pv2-tag-chip"
                  *ngFor="let tag of availableTags"
                  [class.is-active]="editor.classification.tags.includes(tag.nome)"
                  (click)="onClassificationChange(tag.nome)"
                  [disabled]="!podeEditarProdutos">
                  {{ tag.nome }}
                </button>
              </div>
            </div>
          </article>

          <article class="pv2-side-card" *ngIf="activeProductTab === 'fiscal' && temModuloFiscal">
            <header (click)="onFiscalSectionToggle()">
              <h4>Fiscal</h4>
              <span class="fa" [ngClass]="sectionFiscalOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
            </header>
            <div class="pv2-side-body" *ngIf="sectionFiscalOpen">
              <p class="pv2-field-hint" *ngIf="fiscalLoading">Carregando dados fiscais...</p>
              <ng-container *ngIf="dadosFiscais">
                <label class="pv2-form-field">
                  <span>Origem</span>
                  <select [(ngModel)]="editor.fiscal.origem" (ngModelChange)="onFiscalChange()" [disabled]="!podeEditarProdutos">
                    <option [ngValue]="null">Selecione</option>
                    <option *ngFor="let origem of dadosFiscais.origens" [ngValue]="origem">{{ origem.descricao }}</option>
                  </select>
                </label>
                <p class="pv2-field-hint is-error" *ngIf="fiscalValidationMessage">{{ fiscalValidationMessage }}</p>
                <div class="pv2-form-row">
                  <label class="pv2-form-field">
                    <span>NCM</span>
                    <kendo-combobox
                      class="pv2-ncm-combobox"
                      [data]="fiscalNcmOptions"
                      [ngModel]="editor.fiscal.ncm"
                      textField="shortLabel"
                      valueField="codigo"
                      [valuePrimitive]="true"
                      [filterable]="true"
                      [allowCustom]="false"
                      [clearButton]="true"
                      [placeholder]="'Selecione um NCM'"
                      [loading]="fiscalNcmLoading"
                      [disabled]="!podeEditarProdutos"
                      (valueChange)="onFiscalNcmChange($event)"
                      (filterChange)="onFiscalNcmFilterChange($event)">
                      <ng-template kendoComboBoxItemTemplate let-dataItem>
                        <div class="pv2-ncm-option">
                          <span class="pv2-ncm-option__code">{{ dataItem.codigo }}</span>
                          <span class="pv2-ncm-option__description">{{ dataItem.tailDescription || dataItem.descricao }}</span>
                        </div>
                      </ng-template>
                    </kendo-combobox>
                    <p class="pv2-field-hint pv2-ncm-selection-hint" *ngIf="fiscalNcmSelecionado?.descricao && fiscalNcmSelecionado?.descricao !== 'NCM atual nao encontrado na base local.'">
                      {{ fiscalNcmSelecionado?.descricao }}
                    </p>
                  </label>
                  <label class="pv2-form-field">
                    <span>CEST</span>
                    <kendo-combobox
                      class="pv2-ncm-combobox"
                      [data]="fiscalCestOptions"
                      [ngModel]="editor.fiscal.cest"
                      textField="shortLabel"
                      valueField="codigo"
                      [valuePrimitive]="true"
                      [filterable]="true"
                      [allowCustom]="false"
                      [clearButton]="true"
                      [placeholder]="fiscalPodeBuscarCest ? 'Selecione um CEST' : 'Selecione um NCM primeiro'"
                      [loading]="fiscalCestLoading"
                      [disabled]="!podeEditarProdutos || !fiscalPodeBuscarCest"
                      (valueChange)="onFiscalCestChange($event)"
                      (filterChange)="onFiscalCestFilterChange($event)">
                      <ng-template kendoComboBoxItemTemplate let-dataItem>
                        <div class="pv2-ncm-option">
                          <span class="pv2-ncm-option__code">{{ dataItem.codigoFormatado || dataItem.codigo }}</span>
                          <span class="pv2-ncm-option__description">{{ dataItem.tailDescription || dataItem.descricao }}</span>
                        </div>
                      </ng-template>
                    </kendo-combobox>
                    <p class="pv2-field-hint pv2-ncm-selection-hint" *ngIf="fiscalCestSelecionado?.descricao && fiscalCestSelecionado?.descricao !== 'CEST atual nao encontrado para o NCM informado.'">
                      {{ fiscalCestSelecionado?.descricao }}
                    </p>
                  </label>
                </div>
                <div class="pv2-form-row">
                  <label class="pv2-form-field">
                    <span>GTIN</span>
                    <input [ngModel]="editor.fiscal.gtin" (ngModelChange)="onFiscalDigitsFieldChange('gtin', $event, 14)" type="text" maxlength="14" inputmode="numeric" [disabled]="!podeEditarProdutos">
                  </label>
                  <label class="pv2-form-field">
                    <span>Unidade</span>
                    <input [ngModel]="editor.fiscal.unidade" (ngModelChange)="onFiscalUnitFieldChange($event)" type="text" maxlength="3" [disabled]="!podeEditarProdutos">
                  </label>
                </div>

                <label class="pv2-form-field">
                  <span>Tipo cálculo IPI</span>
                  <select [(ngModel)]="editor.fiscal.tipoCalculoIPI" (ngModelChange)="onFiscalChange()" [disabled]="!podeEditarProdutos">
                    <option [ngValue]="null">Selecione</option>
                    <option value="PorAliquota">Por Alíquota</option>
                    <option value="PorValor">Por Valor</option>
                  </select>
                </label>
                <label class="pv2-form-field" *ngIf="editor.fiscal.tipoCalculoIPI === 'PorAliquota'">
                  <span>Alíquota IPI (%)</span>
                  <input [(ngModel)]="editor.fiscal.aliquotaIPI" (ngModelChange)="onFiscalChange()" type="number" step="0.01" min="0" [disabled]="!podeEditarProdutos">
                </label>
                <label class="pv2-form-field" *ngIf="editor.fiscal.tipoCalculoIPI === 'PorValor'">
                  <span>Valor por unidade IPI</span>
                  <input [(ngModel)]="editor.fiscal.valorPorUnidadeIPI" (ngModelChange)="onFiscalChange()" type="number" step="0.01" min="0" [disabled]="!podeEditarProdutos">
                </label>

                <label class="pv2-form-field">
                  <span>Tipo tributação IPI</span>
                  <select [(ngModel)]="editor.fiscal.tipoDeTributacaoIPI" (ngModelChange)="onFiscalChange()" [disabled]="!podeEditarProdutos">
                    <option [ngValue]="null">Selecione</option>
                    <option *ngFor="let tipo of dadosFiscais.tiposTributacaoIPI" [ngValue]="tipo">{{ tipo.descricao }}</option>
                  </select>
                </label>
                <label class="pv2-form-field">
                  <span>Selo de controle IPI</span>
                  <select [(ngModel)]="editor.fiscal.seloDeControleIPI" (ngModelChange)="onFiscalChange()" [disabled]="!podeEditarProdutos">
                    <option [ngValue]="null">Selecione</option>
                    <option *ngFor="let selo of dadosFiscais.selosControleIPI" [ngValue]="selo">{{ selo.descricao }}</option>
                  </select>
                </label>

                <div class="pv2-toggle-row">
                  <span>Produção própria</span>
                  <label class="pv2-switch">
                    <input type="checkbox" [(ngModel)]="editor.fiscal.producaoPropria" (ngModelChange)="onFiscalChange()" [disabled]="!podeEditarProdutos">
                    <span class="pv2-switch-slider"></span>
                  </label>
                </div>
                <div class="pv2-toggle-row">
                  <span>IPI compõe base cálculo ICMS</span>
                  <label class="pv2-switch">
                    <input type="checkbox" [(ngModel)]="editor.fiscal.ipiCompoeBaseCalculoICMS" (ngModelChange)="onFiscalChange()" [disabled]="!podeEditarProdutos">
                    <span class="pv2-switch-slider"></span>
                  </label>
                </div>

                <label class="pv2-form-field">
                  <span>Alíquota tributos aproximados (%)</span>
                  <input [(ngModel)]="editor.fiscal.aliquotaAtributosAproximados" (ngModelChange)="onFiscalChange()" type="number" step="0.01" min="0" [disabled]="!podeEditarProdutos">
                </label>
                <label class="pv2-form-field">
                  <span>Informações adicionais</span>
                  <textarea [(ngModel)]="editor.fiscal.informacoesAdicionais" (ngModelChange)="onFiscalChange()" rows="3" [disabled]="!podeEditarProdutos"></textarea>
                </label>
              </ng-container>
            </div>
          </article>

          <article class="pv2-side-card" *ngIf="activeProductTab === 'fiscal' && pontuarFidelidade">
            <header (click)="sectionFidelidadeOpen = !sectionFidelidadeOpen">
              <h4>Pontuação Fidelidade</h4>
              <span class="fa" [ngClass]="sectionFidelidadeOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
            </header>
            <div class="pv2-side-body" *ngIf="sectionFidelidadeOpen">
              <label class="pv2-form-field" *ngIf="!acumulaReais">
                <span>Pontos ganhos</span>
                <input [(ngModel)]="editor.fidelidade.pontosGanhos" (ngModelChange)="onFidelidadeChange()" type="number" step="1" min="0" [disabled]="!podeEditarProdutos">
              </label>
              <label class="pv2-form-field" *ngIf="acumulaReais">
                <span>Cashback (%)</span>
                <input [(ngModel)]="editor.fidelidade.cashback" (ngModelChange)="onFidelidadeChange()" type="number" step="0.1" min="0" max="100" [disabled]="!podeEditarProdutos">
              </label>
            </div>
          </article>

          <article class="pv2-side-card" *ngIf="activeProductTab === 'fiscal' && temModuloEstoque">
            <header (click)="sectionEstoqueOpen = !sectionEstoqueOpen">
              <h4>Estoque / Insumo</h4>
              <span class="fa" [ngClass]="sectionEstoqueOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
            </header>
            <div class="pv2-side-body" *ngIf="sectionEstoqueOpen"
                 [style.pointer-events]="podeEditarProdutos ? null : 'none'"
                 [style.opacity]="podeEditarProdutos ? null : '0.55'">
              <app-associar-insumo #associacaoEstoque [objeto]="editor.raw"></app-associar-insumo>
              <button type="button" class="btn btn-primary" [disabled]="!podeEditarProdutos || salvandoEstoque"
                      (click)="salveEstoque(associacaoEstoque)">Salvar estoque</button>
            </div>
          </article>
        </section>
        </ng-container>
      </ng-container>

      <ng-template #adicionalEditorTpl>
        <app-tela-editor-adicional-v2
          [editor]="editor"
          [empresa]="empresa"
          [podeEditar]="podeEditarEstruturaAdicional"
          [podeEditarPrecos]="podeEditarPrecoOpcoes"
          [podeEditarDisponibilidade]="podeEditarDisponibilidadeOpcoes"
          [podeEditarExibicaoOpcoes]="podeEditarExibicaoOpcoes"
          [groupId]="getActiveFocusGroupId()"
          [mode]="getActiveGroupDraftMode() === 'create' ? 'create' : 'edit'"
          [crossSellProductId]="crossSellProductId"
          [requestedOptionMode]="optionMode"
          [startWithLibrary]="libraryOpen"
          (closeRequested)="goBack()"
          (groupSaved)="onAdicionalSaved($event)"
          (groupDeleted)="onAdicionalDeleted($event)"
          (groupDuplicated)="onAdicionalDuplicated()"
          (libraryGroupsLinked)="onLibraryGroupsLinked($event)"
          (actionBarStateChange)="onAdicionalActionBarStateChange($event)"
          (libraryRequested)="openLibrary()">
        </app-tela-editor-adicional-v2>
      </ng-template>

      <!-- Legacy group-detail surface (kept as reference) -->
      <ng-template #groupDetailSurfaceTpl>
        <section class="pv2-group-detail-shell">
          <section class="pv2-group-detail-hero">
            <div class="pv2-group-detail-hero__meta">
              <span class="pv2-surface-badge">Editor de adicional</span>
              <h2>{{ groupDraft?.name || 'Novo adicional' }}</h2>
              <p class="pv2-group-detail-hero__subtitle">
                {{ editor.name || 'Novo produto' }}
                <span *ngIf="editor.category">• {{ editor.category }}</span>
                <span *ngIf="groupDraft && groupDraft.options.length">• {{ groupDraft.options.length }} opções</span>
              </p>
            </div>

            <div class="pv2-groups-actions pv2-hero-actions">
              <!-- TODO: Botão "Biblioteca" removido temporariamente — funcionalidade inacabada -->
              <button type="button" class="pv2-ghost-btn pv2-ghost-btn--compact" (click)="openDedicatedEditor()">Abrir produto completo</button>
            </div>
          </section>

          <section class="pv2-group-detail-grid" *ngIf="groupDraft; else missingGroupTpl">
            <article class="pv2-side-card pv2-group-detail-form" [class.is-collapsed-mobile]="groupFormCollapsedMobile && isMobile">
              <header (click)="isMobile ? groupFormCollapsedMobile = !groupFormCollapsedMobile : null">
                <div>
                  <h4>{{ editingGroupId != null ? 'Regras do adicional' : 'Criar adicional' }}</h4>
                  <p *ngIf="canEditGroupStructure(groupDraft) && (!groupFormCollapsedMobile || !isMobile)">Configure a estrutura antes das edições avançadas.</p>
                  <p *ngIf="!canEditGroupStructure(groupDraft)">Estrutura bloqueada neste contexto. Aqui você só edita preços e ativação quando permitido.</p>
                  <div class="pv2-rules-bar" *ngIf="canEditGroupStructure(groupDraft) && groupFormCollapsedMobile && isMobile && groupDraft">
                    <span><i class="fa fa-dot-circle-o"></i> {{ groupDraft.type === 'single' ? 'Única' : groupDraft.type === 'multipleRepeat' ? 'Múltipla c/ rep.' : 'Múltipla' }}</span>
                    <span class="pv2-rules-bar__sep"></span>
                    <span [class.is-alert]="groupDraft.required"><i class="fa fa-exclamation-circle"></i> {{ groupDraft.required ? 'Obrigatório' : 'Opcional' }}</span>
                    <span class="pv2-rules-bar__sep"></span>
                    <span><i class="fa fa-arrows-h"></i> {{ groupDraft.min }}–{{ groupDraft.max }}</span>
                    <span class="pv2-rules-bar__sep"></span>
                    <span><i class="fa fa-calculator"></i> {{ groupDraft.chargeType | titlecase }}</span>
                    <span class="pv2-rules-bar__sep"></span>
                    <span><i class="fa fa-clone"></i> {{ getQuantityBehaviorLabel(groupDraft.multiplicaQuantidadeProduto) }}</span>
                  </div>
                </div>
                <button type="button" class="pv2-icon-btn pv2-form-collapse-toggle" *ngIf="isMobile">
                  <span class="fa" [ngClass]="groupFormCollapsedMobile ? 'fa-chevron-down' : 'fa-chevron-up'"></span>
                </button>
              </header>

              <div class="pv2-group-detail-form__body" *ngIf="canEditGroupStructure(groupDraft)" [class.is-hidden-mobile]="groupFormCollapsedMobile && isMobile">
                <label class="pv2-form-field">
                  <span>Nome do adicional</span>
                  <input [(ngModel)]="groupDraft.name" type="text">
                </label>

                <div class="pv2-form-section">
                  <span class="pv2-form-section__label">Tipo de seleção</span>
                  <div class="pv2-pill-grid">
                    <button type="button" class="pv2-pill" [class.is-active]="groupDraft.type === 'single'" (click)="groupDraft.type = 'single'">
                      <span class="fa fa-dot-circle-o"></span> Única
                    </button>
                    <button type="button" class="pv2-pill" [class.is-active]="groupDraft.type === 'multiple'" (click)="groupDraft.type = 'multiple'">
                      <span class="fa fa-check-square"></span> Múltipla
                    </button>
                    <button type="button" class="pv2-pill" [class.is-active]="groupDraft.type === 'multipleRepeat'" (click)="groupDraft.type = 'multipleRepeat'">
                      <span class="fa fa-clone"></span> Múltipla c/ rep.
                    </button>
                  </div>
                </div>

                <label class="pv2-toggle-row pv2-toggle-box">
                  <div class="pv2-toggle-box__label">
                    <span class="fa fa-exclamation-circle"></span>
                    <span>Obrigatório</span>
                  </div>
                  <div class="pv2-toggle-switch">
                    <input type="checkbox" [(ngModel)]="groupDraft.required">
                    <span class="pv2-toggle-switch__track"></span>
                  </div>
                </label>

                <div class="pv2-form-grid">
                  <label class="pv2-form-field">
                    <span>Mínimo</span>
                    <input [(ngModel)]="groupDraft.min" type="number" min="0">
                  </label>

                  <label class="pv2-form-field">
                    <span>Máximo</span>
                    <input [(ngModel)]="groupDraft.max" type="number" min="1">
                  </label>
                </div>

                <div class="pv2-form-section">
                  <span class="pv2-form-section__label">Tipo de cobrança</span>
                  <div class="pv2-pill-grid">
                    <button type="button" class="pv2-pill" [class.is-active]="groupDraft.chargeType === 'soma'" (click)="groupDraft.chargeType = 'soma'">
                      <span class="fa fa-plus-circle"></span> Soma
                    </button>
                    <button type="button" class="pv2-pill" [class.is-active]="groupDraft.chargeType === 'media'" (click)="groupDraft.chargeType = 'media'">
                      <span class="fa fa-balance-scale"></span> Média
                    </button>
                    <button type="button" class="pv2-pill" [class.is-active]="groupDraft.chargeType === 'maior'" (click)="groupDraft.chargeType = 'maior'">
                      <span class="fa fa-arrow-up"></span> Maior
                    </button>
                  </div>
                </div>

                <div class="pv2-inline-quantity">
                  <span class="pv2-form-section__label">Como o adicional entra no pedido</span>
                  <div class="pv2-inline-quantity__cards">
                    <button type="button"
                            class="pv2-inline-quantity__card"
                            [class.is-active]="groupDraft.multiplicaQuantidadeProduto !== false"
                            (click)="groupDraft.multiplicaQuantidadeProduto = true">
                      <div class="pv2-inline-quantity__card-head">
                        <div class="pv2-inline-quantity__card-title">
                          <strong>Por unidade do produto</strong>
                          <span class="pv2-inline-quantity__chip">Por unidade do produto</span>
                        </div>
                        <span class="pv2-inline-quantity__radio" [class.is-active]="groupDraft.multiplicaQuantidadeProduto !== false"></span>
                      </div>
                      <p>{{ getQuantityBehaviorDescription(true) }}</p>
                      <small *ngIf="groupDraft.multiplicaQuantidadeProduto !== false">{{ getQuantityBehaviorExample(true) }}</small>
                    </button>

                    <button type="button"
                            class="pv2-inline-quantity__card"
                            [class.is-active]="groupDraft.multiplicaQuantidadeProduto === false"
                            [disabled]="!quantityModeRolloutEnabled"
                            (click)="groupDraft.multiplicaQuantidadeProduto = false">
                      <div class="pv2-inline-quantity__card-head">
                        <div class="pv2-inline-quantity__card-title">
                          <strong>Item complementar</strong>
                          <span class="pv2-inline-quantity__chip is-muted">Item complementar</span>
                        </div>
                        <span class="pv2-inline-quantity__radio" [class.is-active]="groupDraft.multiplicaQuantidadeProduto === false"></span>
                      </div>
                      <p>{{ getQuantityBehaviorDescription(false) }}</p>
                      <small *ngIf="groupDraft.multiplicaQuantidadeProduto === false">{{ getQuantityBehaviorExample(false) }}</small>
                    </button>
                  </div>
                  <small class="text-muted d-block mt-2" *ngIf="!quantityModeRolloutEnabled">O modo "item complementar" está temporariamente indisponível nesta fase de estabilização.</small>
                </div>

                <!-- TODO: "Compartilhar na biblioteca" removido temporariamente — biblioteca inacabada -->

                <div class="pv2-group-detail-form__actions">
                  <button type="button" class="pv2-remove-group-btn" *ngIf="focusedGroup && focusedGroup.kind !== 'pizza-sizes'" (click)="removeGroup(focusedGroup)">
                    <span class="fa fa-trash"></span>
                  </button>
                  <button type="button" class="pv2-primary-btn pv2-full-btn" (click)="saveGroupPanel()">Salvar adicional</button>
                </div>
              </div>

              <div class="pv2-group-detail-form__body" *ngIf="!canEditGroupStructure(groupDraft)">
                <div class="pv2-empty pv2-empty--inline">
                  <h3>Estrutura fixa</h3>
                  <p>Os tamanhos da pizza não usam tipo, obrigatoriedade, cobrança ou compartilhamento editáveis na V2.</p>
                </div>
              </div>
            </article>

            <article class="pv2-group-card pv2-group-detail-options">
              <header class="pv2-gd-header" [ngClass]="modeThemeClass">
                <div class="pv2-gd-header__icon">
                  {{ getEditorPlaceholder() }}
                </div>
                <div class="pv2-gd-header__info">
                  <span class="pv2-gd-header__breadcrumb" *ngIf="isMobile">
                    {{ editor.name || 'Produto' }}<span *ngIf="editor.category"> · {{ editor.category }}</span>
                  </span>
                  <h4>{{ (focusedGroup || groupDraft).name || 'Novo adicional' }}</h4>
                  <span class="pv2-gd-header__counts">
                    {{ groupActiveCount }} ativas &middot; {{ groupTotalCount }} total
                  </span>
                </div>
                <button type="button" class="pv2-ghost-btn pv2-gd-header__edit" *ngIf="canEditGroupStructure(focusedGroup || groupDraft)"
                        (click)="openGroupPanel(focusedGroup || undefined); $event.stopPropagation()">
                  <span class="fa fa-pencil"></span>
                  Editar
                </button>
                <div class="pv2-gd-header__mobile-actions" *ngIf="isMobile">
                  <!-- TODO: Botão "Biblioteca" mobile removido temporariamente -->
                  <button type="button" class="pv2-gd-mobile-action" (click)="openDedicatedEditor()">
                    <span class="fa fa-external-link"></span>
                  </button>
                </div>
              </header>

              <div class="pv2-group-warning" *ngIf="focusedGroup?.shared">
                <span class="fa fa-link"></span>
                Compartilhado em {{ focusedGroup?.sharedCount }} produtos
              </div>

              <ng-container *ngIf="focusedGroup; else createGroupHintTpl">
                <section class="pv2-group-workspace">
                  <div class="pv2-group-mode-switch" [ngClass]="modeThemeClass">
                    <button type="button" class="pv2-group-mode-switch__btn"
                            [class.is-active]="isReviewMode"
                            [ngClass]="{'is-editar': isReviewMode}"
                            (click)="setOptionMode('review')"
                            [disabled]="!podeEditarAlgumaOpcao">
                      <span class="fa fa-pencil"></span>
                      Editar
                    </button>
                    <button type="button" class="pv2-group-mode-switch__btn"
                            [class.is-active]="isActivationMode"
                            [ngClass]="{'is-onoff': isActivationMode}"
                            (click)="setOptionMode('activation')"
                            [disabled]="!podeEditarDisponibilidadeOpcoes">
                      <span class="fa fa-toggle-on"></span>
                      Ativar/Desativar
                    </button>
                    <button type="button" class="pv2-group-mode-switch__btn"
                            *ngIf="!temModuloTabelaPrecos"
                            [class.is-active]="isBatchPriceMode"
                            [ngClass]="{'is-lote': isBatchPriceMode}"
                            (click)="setOptionMode('batch-price')"
                            [disabled]="!podeEditarPrecoOpcoes">
                      <span class="fa fa-th"></span>
                      Preço em massa
                    </button>
                  </div>

                  <div class="pv2-gd-banner" [ngClass]="modeThemeClass">
                    <span class="pv2-gd-banner__icon">
                      <span class="fa" [ngClass]="{
                        'fa-check-circle': isActivationMode,
                        'fa-pencil': isReviewMode,
                        'fa-check-square': isBatchPriceMode
                      }"></span>
                    </span>
                    <span *ngIf="isActivationMode">Toque para ativar/desativar</span>
                    <span *ngIf="isReviewMode">Toque no item para editar</span>
                    <span *ngIf="isBatchPriceMode">Selecione para ações em massa</span>
                  </div>

                  <section class="pv2-group-detail-options-shell">
                    <div class="pv2-gd-toolbar">
                      <label class="pv2-search pv2-gd-search">
                        <span class="fa fa-search"></span>
                        <input [ngModel]="optionSearch" (ngModelChange)="setOptionSearch($event)"
                               type="text" placeholder="Buscar...">
                      </label>

                      <div class="pv2-gd-sort-row">
                        <div class="pv2-gd-sort">
                          <button type="button" class="pv2-chip" [class.is-active]="optionSort === 'name-asc'"
                                  (click)="setOptionSort('name-asc')">A-Z</button>
                          <button type="button" class="pv2-chip" [class.is-active]="optionSort === 'price-asc'"
                                  (click)="setOptionSort('price-asc')">R$ &#8593;</button>
                          <button type="button" class="pv2-chip" [class.is-active]="optionSort === 'price-desc'"
                                  (click)="setOptionSort('price-desc')">R$ &#8595;</button>
                        </div>
                        <span class="pv2-gd-item-count">{{ filteredFocusedGroupOptions.length }} itens</span>
                      </div>
                    </div>

                    <div class="pv2-gd-batch-bar" *ngIf="isBatchPriceMode && !temModuloTabelaPrecos">
                      <div class="pv2-gd-batch-bar__counter">
                        <strong>{{ batchSelectedCount }}/{{ filteredFocusedGroupOptions.length }}</strong>
                        <button type="button" class="pv2-chip" (click)="selectAllFilteredBatchOptions()">Todos</button>
                        <button type="button" class="pv2-chip" (click)="clearBatchSelection()">Nenhum</button>
                      </div>
                      <div class="pv2-gd-batch-bar__actions">
                        <button type="button" class="pv2-primary-btn pv2-gd-batch-bar__price-btn"
                                (click)="openBatchSheet()"
                                [disabled]="!podeEditarPrecoOpcoes">
                          Alterar preço
                        </button>
                        <button type="button" class="pv2-gd-batch-bar__on-btn"
                                (click)="applyBatchAvailability(true)"
                                [disabled]="!podeEditarDisponibilidadeOpcoes">
                          <span class="fa fa-check"></span> Ativar
                        </button>
                        <button type="button" class="pv2-gd-batch-bar__off-btn"
                                (click)="applyBatchAvailability(false)"
                                [disabled]="!podeEditarDisponibilidadeOpcoes">
                          <span class="fa fa-ban"></span> Desativar
                        </button>
                      </div>
                    </div>

                    <div class="pv2-gd-chip-flow" [ngClass]="modeThemeClass"
                         *ngIf="filteredFocusedGroupOptions.length; else emptyGroupFilterTpl">

                      <ng-container *ngIf="isActivationMode">
                        <button type="button" class="pv2-option-chip is-mode-onoff"
                                *ngFor="let option of filteredFocusedGroupOptions; trackBy: trackByOption"
                                [class.is-active]="option.active !== false"
                                [class.is-inactive]="option.active === false"
                                (click)="onChipClickOnOff(option)"
                                [disabled]="!podeEditarDisponibilidadeOpcoes">
                          <span class="pv2-option-chip__status-dot"
                                [class.is-on]="option.active !== false">
                            <span class="fa fa-check" *ngIf="option.active !== false"></span>
                          </span>
                          <span class="pv2-option-chip__name">{{ option.name || 'Sem nome' }}</span>
                          <span class="pv2-option-chip__price">R${{ option.price | number:'1.0-0':'pt' }}</span>
                        </button>
                      </ng-container>

                      <ng-container *ngIf="isReviewMode">
                        <button type="button" class="pv2-option-chip is-mode-editar"
                                *ngFor="let option of filteredFocusedGroupOptions; trackBy: trackByOption"
                                [class.is-active]="option.active !== false"
                                [class.is-inactive]="option.active === false"
                                [class.is-editing]="isEditingOption(option)"
                                (click)="onChipClickEditar(option)"
                                [disabled]="!podeEditarAlgumaOpcao">
                          <span class="pv2-option-chip__edit-dot">
                            <span class="fa fa-pencil"></span>
                          </span>
                          <span class="pv2-option-chip__name">{{ option.name || 'Sem nome' }}</span>
                          <span class="pv2-option-chip__price">R${{ option.price | number:'1.0-0':'pt' }}</span>
                        </button>
                      </ng-container>

                      <ng-container *ngIf="isBatchPriceMode">
                        <button type="button" class="pv2-option-chip is-mode-lote"
                                *ngFor="let option of filteredFocusedGroupOptions; trackBy: trackByOption"
                                [class.is-selected]="isBatchOptionSelected(option)"
                                (click)="onChipClickLote(option)"
                                [disabled]="!podeEditarPrecoOpcoes">
                          <span class="pv2-option-chip__name">{{ option.name || 'Sem nome' }}</span>
                          <span class="pv2-option-chip__price">R${{ option.price | number:'1.0-0':'pt' }}</span>
                        </button>
                      </ng-container>
                    </div>

                    <div class="pv2-gd-chip-footer" *ngIf="isReviewMode">
                      <button type="button" class="pv2-add-option-btn"
                              *ngIf="focusedGroup?.kind !== 'pizza-sizes'"
                              (click)="addOptionFromFocusedGroup()"
                              [disabled]="!podeEditarEstruturaAdicional">
                        + Adicionar opção
                      </button>
                    </div>
                  </section>
                </section>
              </ng-container>

              <ng-template #createGroupHintTpl>
                <section class="pv2-draft-options">
                  <div class="pv2-draft-options__header">
                    <h4>Opções do adicional</h4>
                    <p>Adicione pelo menos 1 opção para salvar.</p>
                  </div>

                  <div class="pv2-draft-chips" *ngIf="draftOptions.length > 0">
                    <span class="pv2-draft-chip" *ngFor="let opt of draftOptions; let i = index">
                      {{ opt.name }}
                      <button type="button" (click)="removeDraftOption(i)">
                        <span class="fa fa-times"></span>
                      </button>
                    </span>
                  </div>

                  <div class="pv2-draft-input-row">
                    <input type="text" class="pv2-draft-input"
                           [(ngModel)]="draftOptionInput"
                           placeholder="Digite o nome e aperte Enter..."
                           (keydown.enter)="addDraftOptionFromInput()">
                    <button type="button" class="pv2-draft-add-btn"
                            [disabled]="!draftOptionInput.trim()"
                            (click)="addDraftOptionFromInput()">
                      <span class="fa fa-plus"></span>
                    </button>
                  </div>

                  <p class="pv2-draft-hint" *ngIf="draftOptions.length === 0">
                    <span class="fa fa-info-circle"></span>
                    Os preços podem ser definidos após salvar.
                  </p>
                </section>
              </ng-template>

              <ng-template #emptyGroupFilterTpl>
                <div class="pv2-empty pv2-empty--inline pv2-empty--compact">
                  <h3>Nenhuma opção encontrada</h3>
                  <p>Ajuste a busca ou o filtro para voltar a exibir as opções deste adicional.</p>
                </div>
              </ng-template>
            </article>
          </section>
        </section>

        <section class="pv2-inline-library-panel" *ngIf="shouldShowInlineLibrary">
          <header>
            <div>
              <h4>Biblioteca</h4>
              <p>Vincule ou duplique adicionais existentes</p>
            </div>
            <button type="button" class="pv2-icon-btn" (click)="closeLibrary()"><span class="fa fa-times"></span></button>
          </header>

          <label class="pv2-search">
            <span class="fa fa-search"></span>
            <input [(ngModel)]="librarySearch" (ngModelChange)="refreshLibrary()" type="text" placeholder="Buscar adicional...">
          </label>

          <div class="pv2-chip-row">
            <button type="button" class="pv2-chip" [class.is-active]="libraryFilter === 'Todos'" (click)="libraryFilter = 'Todos'">Todos</button>
            <button type="button" class="pv2-chip" [class.is-active]="libraryFilter === 'Mais usados'" (click)="libraryFilter = 'Mais usados'">Mais usados</button>
            <button type="button" class="pv2-chip" [class.is-active]="libraryFilter === 'Recentes'" (click)="libraryFilter = 'Recentes'">Recentes</button>
          </div>

          <div class="pv2-library-list" *ngIf="!libraryLoading; else inlineLibraryLoadingTpl">
            <article class="pv2-library-card" *ngFor="let item of filteredLibraryItems">
              <h4>{{ item.name }}</h4>
              <p>{{ item.usageLabel }}</p>
              <div class="pv2-library-actions">
                <button type="button" class="pv2-primary-btn" (click)="useLibraryGroup(item, false)" [disabled]="!podeEditarProdutos">Vincular</button>
                <button type="button" class="pv2-ghost-btn" (click)="useLibraryGroup(item, true)" [disabled]="!podeEditarProdutos">Duplicar</button>
              </div>
            </article>
          </div>

          <ng-template #inlineLibraryLoadingTpl>
            <div class="pv2-library-card is-loading" *ngFor="let skeleton of [1,2,3]">
              <div class="pv2-skel pv2-skel-line"></div>
              <div class="pv2-skel pv2-skel-line pv2-skel-line-md"></div>
              <div class="pv2-skel pv2-skel-line pv2-skel-line-sm"></div>
            </div>
          </ng-template>
        </section>

        <ng-template #missingGroupTpl>
          <div class="pv2-empty">
            <h3>Adicional não encontrado</h3>
            <p>Volte para o produto e escolha outro adicional para continuar.</p>
          </div>
        </ng-template>
      </ng-template>

      <section class="pv2-inline-library-panel" *ngIf="!isGroupDetailSurface && libraryOpen">
        <header>
          <div>
            <h4>Biblioteca</h4>
            <p>Vincule ou duplique adicionais existentes</p>
          </div>
          <button type="button" class="pv2-icon-btn" (click)="closeLibrary()"><span class="fa fa-times"></span></button>
        </header>

        <label class="pv2-search">
          <span class="fa fa-search"></span>
          <input [(ngModel)]="librarySearch" (ngModelChange)="refreshLibrary()" type="text" placeholder="Buscar adicional...">
        </label>

        <div class="pv2-chip-row">
          <button type="button" class="pv2-chip" [class.is-active]="libraryFilter === 'Todos'" (click)="libraryFilter = 'Todos'">Todos</button>
          <button type="button" class="pv2-chip" [class.is-active]="libraryFilter === 'Mais usados'" (click)="libraryFilter = 'Mais usados'">Mais usados</button>
          <button type="button" class="pv2-chip" [class.is-active]="libraryFilter === 'Recentes'" (click)="libraryFilter = 'Recentes'">Recentes</button>
        </div>

        <div class="pv2-library-list" *ngIf="!libraryLoading; else inlineLibraryLoadingTpl">
          <article class="pv2-library-card" *ngFor="let item of filteredLibraryItems">
            <h4>{{ item.name }}</h4>
            <p>{{ item.usageLabel }}</p>
            <div class="pv2-library-actions">
              <button type="button" class="pv2-primary-btn" (click)="useLibraryGroup(item, false)">Vincular</button>
              <button type="button" class="pv2-ghost-btn" (click)="useLibraryGroup(item, true)">Duplicar</button>
            </div>
          </article>
        </div>

        <ng-template #inlineLibraryLoadingTpl>
          <div class="pv2-library-card is-loading" *ngFor="let skeleton of [1,2,3]">
            <div class="pv2-skel pv2-skel-line"></div>
            <div class="pv2-skel pv2-skel-line pv2-skel-line-md"></div>
            <div class="pv2-skel pv2-skel-line pv2-skel-line-sm"></div>
          </div>
        </ng-template>
      </section>
    </main>
  </div>

  <button class="pv2-mobile-cta" *ngIf="isMobile && !isGroupDetailSurface" type="button" (click)="openGroupPanel()" [disabled]="!podeEditarProdutos"><i class="fa fa-plus"></i> Novo Adicional</button>

  <kendo-dialog class="pv2-editor-native-dialog" [title]="groupPanelTitle" *ngIf="groupPanelOpen && groupDraft" [minWidth]="340" [width]="480" (close)="closeGroupPanel()">
    <ng-container *ngIf="canEditGroupStructure(groupDraft); else fixedGroupPanelTpl">
    <label class="pv2-form-field">
      <span>Nome do adicional</span>
      <input [(ngModel)]="groupDraft.name" type="text">
    </label>

    <div class="pv2-form-section">
      <span class="pv2-form-section__label">Tipo de seleção</span>
      <div class="pv2-pill-grid">
        <button type="button" class="pv2-pill" [class.is-active]="groupDraft.type === 'single'" (click)="groupDraft.type = 'single'">
          <span class="fa fa-dot-circle-o"></span> Única
        </button>
        <button type="button" class="pv2-pill" [class.is-active]="groupDraft.type === 'multiple'" (click)="groupDraft.type = 'multiple'">
          <span class="fa fa-check-square"></span> Múltipla
        </button>
        <button type="button" class="pv2-pill" [class.is-active]="groupDraft.type === 'multipleRepeat'" (click)="groupDraft.type = 'multipleRepeat'">
          <span class="fa fa-clone"></span> Múltipla c/ rep.
        </button>
      </div>
    </div>

    <label class="pv2-toggle-row pv2-toggle-box">
      <div class="pv2-toggle-box__label">
        <span class="fa fa-exclamation-circle"></span>
        <span>Obrigatório</span>
      </div>
      <div class="pv2-toggle-switch">
        <input type="checkbox" [(ngModel)]="groupDraft.required">
        <span class="pv2-toggle-switch__track"></span>
      </div>
    </label>

    <div class="pv2-form-grid">
      <label class="pv2-form-field">
        <span>Mínimo</span>
        <input [(ngModel)]="groupDraft.min" type="number" min="0">
      </label>

      <label class="pv2-form-field">
        <span>Máximo</span>
        <input [(ngModel)]="groupDraft.max" type="number" min="1">
      </label>
    </div>

    <div class="pv2-form-section">
      <span class="pv2-form-section__label">Tipo de cobrança</span>
      <div class="pv2-pill-grid">
        <button type="button" class="pv2-pill" [class.is-active]="groupDraft.chargeType === 'soma'" (click)="groupDraft.chargeType = 'soma'">
          <span class="fa fa-plus-circle"></span> Soma
        </button>
        <button type="button" class="pv2-pill" [class.is-active]="groupDraft.chargeType === 'media'" (click)="groupDraft.chargeType = 'media'">
          <span class="fa fa-balance-scale"></span> Média
        </button>
        <button type="button" class="pv2-pill" [class.is-active]="groupDraft.chargeType === 'maior'" (click)="groupDraft.chargeType = 'maior'">
          <span class="fa fa-arrow-up"></span> Maior
        </button>
      </div>
    </div>

    <div class="pv2-inline-quantity">
      <span class="pv2-form-section__label">Como o adicional entra no pedido</span>
      <div class="pv2-inline-quantity__cards">
        <button type="button"
                class="pv2-inline-quantity__card"
                [class.is-active]="groupDraft.multiplicaQuantidadeProduto !== false"
                (click)="groupDraft.multiplicaQuantidadeProduto = true">
          <div class="pv2-inline-quantity__card-head">
            <div class="pv2-inline-quantity__card-title">
              <strong>Por unidade do produto</strong>
              <span class="pv2-inline-quantity__chip">Por unidade do produto</span>
            </div>
            <span class="pv2-inline-quantity__radio" [class.is-active]="groupDraft.multiplicaQuantidadeProduto !== false"></span>
          </div>
          <p>{{ getQuantityBehaviorDescription(true) }}</p>
          <small *ngIf="groupDraft.multiplicaQuantidadeProduto !== false">{{ getQuantityBehaviorExample(true) }}</small>
        </button>

        <button type="button"
                class="pv2-inline-quantity__card"
                [class.is-active]="groupDraft.multiplicaQuantidadeProduto === false"
                [disabled]="!quantityModeRolloutEnabled"
                (click)="groupDraft.multiplicaQuantidadeProduto = false">
          <div class="pv2-inline-quantity__card-head">
            <div class="pv2-inline-quantity__card-title">
              <strong>Item complementar</strong>
              <span class="pv2-inline-quantity__chip is-muted">Item complementar</span>
            </div>
            <span class="pv2-inline-quantity__radio" [class.is-active]="groupDraft.multiplicaQuantidadeProduto === false"></span>
          </div>
          <p>{{ getQuantityBehaviorDescription(false) }}</p>
          <small *ngIf="groupDraft.multiplicaQuantidadeProduto === false">{{ getQuantityBehaviorExample(false) }}</small>
        </button>
      </div>
      <small class="text-muted d-block mt-2" *ngIf="!quantityModeRolloutEnabled">O modo "item complementar" está temporariamente indisponível nesta fase de estabilização.</small>
    </div>

    <!-- TODO: "Compartilhar na biblioteca" removido temporariamente — biblioteca inacabada -->
    </ng-container>

    <kendo-dialog-actions>
      <button type="button" class="pv2-primary-btn pv2-full-btn" (click)="saveGroupPanel()">Salvar adicional</button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <ng-template #fixedGroupPanelTpl>
    <div class="pv2-empty pv2-empty--inline">
      <h3>Estrutura fixa</h3>
      <p>Edite apenas preços e ativação quando este contexto permitir.</p>
    </div>
  </ng-template>

  <!-- TODO: Diálogo "Biblioteca" removido temporariamente — funcionalidade inacabada (painel não renderizava + endpoint retorna dados incompatíveis com o facade) -->

  <kendo-dialog class="pv2-editor-native-dialog" title="Preview do cardápio" *ngIf="previewOpen" [minWidth]="340" [width]="480" (close)="closePreview()">
    <p style="color: #64748b; font-size: 13px; margin: 0 0 16px;">Visualização aproximada do produto para o cliente final</p>

    <div class="pv2-preview-card">
      <div class="pv2-preview-cover" [class.has-image]="hasEditorImage()">
        <img [hidden]="!hasEditorImage()" [src]="editor.image" [alt]="editor.name" (error)="onEditorImageError()">
        <span [hidden]="hasEditorImage()">{{ getEditorPlaceholder() }}</span>
      </div>
      <div class="pv2-preview-body">
        <h4>{{ editor.name }}</h4>
        <p>{{ editor.description }}</p>
        <strong *ngIf="editor.type !== 'pizza'">A partir de R$ {{ precoExibidoNaPrevia | number:'1.2-2':'pt' }}</strong>
        <strong *ngIf="editor.type === 'pizza'">Escolha o tamanho para definir o preço</strong>
      </div>

      <div class="pv2-preview-group" *ngFor="let group of editor.groups">
        <div class="pv2-preview-group-head">
          <span>{{ group.name }}</span>
          <span class="pv2-required-badge" *ngIf="group.required">Obrigatório</span>
        </div>

        <label class="pv2-preview-option" *ngFor="let option of group.options">
          <input [type]="group.type === 'single' ? 'radio' : 'checkbox'" [name]="'preview-' + group.id">
          <span>{{ option.name }}</span>
          <strong *ngIf="option.price > 0">+R$ {{ option.price | number:'1.2-2':'pt' }}</strong>
        </label>
      </div>

      <button type="button" class="pv2-primary-btn pv2-full-btn" disabled>
        Adicionar — R$ {{ precoExibidoNaPrevia | number:'1.2-2':'pt' }}
      </button>
    </div>
  </kendo-dialog>

  <kendo-dialog class="pv2-editor-native-dialog pv2-confirm-dialog" [title]="confirmacao.titulo"
                *ngIf="confirmacao.aberta" [minWidth]="320" [width]="460"
                (close)="confirmacao.cancele()">
    <p class="pv2-confirm-dialog__body">{{ confirmacao.mensagem }}</p>
    <kendo-dialog-actions>
      <button type="button" class="pv2-ghost-btn" (click)="confirmacao.cancele()">
        {{ confirmacao.textoCancelar }}
      </button>
      <button type="button" *ngFor="let acao of confirmacao.acoes"
              [class]="confirmacao.classeDaAcao(acao)"
              (click)="confirmacao.escolha(acao.valor)">
        {{ acao.texto }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <div class="pv2-overlay pv2-overlay--sheet" *ngIf="batchSheetOpen && !temModuloTabelaPrecos" (click)="closeBatchSheet()"></div>
  <section class="pv2-batch-sheet" *ngIf="batchSheetOpen && !temModuloTabelaPrecos">
    <div class="pv2-batch-sheet__handle"></div>
    <header class="pv2-batch-sheet__header">
      <div>
        <h3>Alterar preço</h3>
        <span>{{ batchSelectedCount }} selecionados</span>
      </div>
      <button type="button" class="pv2-icon-btn" (click)="closeBatchSheet()">
        <span class="fa fa-times"></span>
      </button>
    </header>

    <div class="pv2-batch-sheet__tabs">
      <button type="button" class="pv2-batch-sheet__tab"
              [class.is-active]="batchAdjustMode === 'increment'"
              (click)="setBatchAdjustMode('increment')">+/-</button>
      <button type="button" class="pv2-batch-sheet__tab"
              [class.is-active]="batchAdjustMode === 'percent'"
              (click)="setBatchAdjustMode('percent')">%</button>
      <button type="button" class="pv2-batch-sheet__tab"
              [class.is-active]="batchAdjustMode === 'fixed'"
              (click)="setBatchAdjustMode('fixed')">Fixo</button>
    </div>

    <div class="pv2-batch-sheet__body">
      <div class="pv2-batch-sheet__direction" *ngIf="batchAdjustMode !== 'fixed'">
        <button type="button"
                class="pv2-batch-sheet__direction-btn"
                [class.is-active]="batchAdjustDirection === 'increase'"
                (click)="setBatchAdjustDirection('increase')">
          Aumentar
        </button>
        <button type="button"
                class="pv2-batch-sheet__direction-btn"
                [class.is-active]="batchAdjustDirection === 'decrease'"
                (click)="setBatchAdjustDirection('decrease')">
          Reduzir
        </button>
      </div>
      <label class="pv2-batch-sheet__field">
        <span *ngIf="batchAdjustMode === 'fixed'">R$</span>
        <span *ngIf="batchAdjustMode === 'increment'">R$</span>
        <span *ngIf="batchAdjustMode === 'percent'">%</span>
        <input [(ngModel)]="batchAdjustValue" type="text" inputmode="decimal"
               placeholder="0"
               [disabled]="!podeEditarPrecoOpcoes">
      </label>
      <button type="button" class="pv2-primary-btn pv2-full-btn pv2-batch-sheet__apply"
              (click)="applyBatchAdjust()"
              [disabled]="!podeEditarPrecoOpcoes">
        Aplicar
      </button>
    </div>
  </section>

  <div class="pv2-overlay pv2-overlay--sheet" *ngIf="editSheetOpen" (click)="closeEditSheet()"></div>
  <section class="pv2-edit-sheet" *ngIf="editSheetOpen">
    <div class="pv2-edit-sheet__handle"></div>
    <header class="pv2-edit-sheet__header">
      <h3>Editar opção</h3>
      <button type="button" class="pv2-icon-btn" (click)="closeEditSheet()">
        <span class="fa fa-times"></span>
      </button>
    </header>

    <div class="pv2-edit-sheet__body">
      <label class="pv2-edit-sheet__field">
        <span>Nome</span>
        <input [(ngModel)]="editingOptionName" placeholder="Nome da opção"
               (keydown.enter)="saveAndCloseEditSheet()" (keydown.escape)="closeEditSheet()"
               [disabled]="!podeEditarEstruturaAdicional">
      </label>

      <label class="pv2-edit-sheet__field">
        <span>Descrição</span>
        <input [(ngModel)]="editingOptionDescription" placeholder="Descrição da opção (opcional)"
               (keydown.escape)="closeEditSheet()"
               [disabled]="!podeEditarEstruturaAdicional">
      </label>

      <label class="pv2-edit-sheet__field pv2-edit-sheet__field--kendo">
        <span>R$</span>
        <kendo-numerictextbox [(ngModel)]="editingOptionPrice"
                              [min]="0" [spinners]="false" [format]="'n2'"
                              placeholder="0,00"
                              [disabled]="!podeEditarPrecoOpcoes">
        </kendo-numerictextbox>
      </label>

      <div class="pv2-edit-sheet__toggle-row">
        <span>Disponível</span>
        <label class="pv2-switch">
          <input type="checkbox" [(ngModel)]="editingOptionActive"
                 [disabled]="!podeEditarDisponibilidadeOpcoes">
          <span class="pv2-switch-slider"></span>
        </label>
      </div>

      <ng-container *ngIf="focusedGroup?.kind !== 'pizza-sizes'">
        <h5 class="pv2-subsection-title">Onde exibir</h5>

        <div class="pv2-edit-sheet__toggle-row">
          <span>Cardápio de delivery</span>
          <label class="pv2-switch">
            <input type="checkbox" [(ngModel)]="editingOptionDisponivelParaDelivery"
                   [disabled]="!podeEditarExibicaoOpcoes">
            <span class="pv2-switch-slider"></span>
          </label>
        </div>

        <div class="pv2-edit-sheet__toggle-row">
          <span>Cardápio de mesa</span>
          <label class="pv2-switch">
            <input type="checkbox" [(ngModel)]="editingOptionDisponivelNaMesa"
                   [disabled]="!podeEditarExibicaoOpcoes">
            <span class="pv2-switch-slider"></span>
          </label>
        </div>

        <p class="pv2-field-hint" *ngIf="!podeEditarExibicaoOpcoes">
          Controlado pelo catálogo da rede.
        </p>
      </ng-container>

      <ng-container *ngIf="focusedGroup?.kind === 'pizza-sizes' && getEditingOption() as editOpt">
        <label class="pv2-edit-sheet__field">
          <span>Código PDV</span>
          <input [(ngModel)]="editOpt.codigoPdv" placeholder="Código PDV do tamanho"
                 [disabled]="!podeEditarEstruturaAdicional">
        </label>

        <ng-container *ngIf="!temModuloTabelaPrecos">
          <h5 class="pv2-subsection-title">Desconto por tamanho</h5>
          <ng-container *ngIf="editOpt.novoPreco != null || editOpt.percentualDesconto != null">
            <label class="pv2-edit-sheet__field">
              <span>Novo preço (R$)</span>
              <input [(ngModel)]="editOpt.novoPreco" (ngModelChange)="alterouNovoPrecoTamanho(editOpt)" type="number" step="0.01" min="0"
                     [disabled]="!podeEditarPrecoOpcoes">
            </label>
            <label class="pv2-edit-sheet__field">
              <span>Desconto (%)</span>
              <input [(ngModel)]="editOpt.percentualDesconto" (ngModelChange)="alterouPercentualDescontoTamanho(editOpt)" type="number" step="0.01" min="0" max="100"
                     [disabled]="!podeEditarPrecoOpcoes">
            </label>
            <div class="pv2-edit-sheet__toggle-row">
              <span>Destaque</span>
              <label class="pv2-switch">
                <input type="checkbox" [(ngModel)]="editOpt.destaque"
                       [disabled]="!podeEditarPrecoOpcoes">
                <span class="pv2-switch-slider"></span>
              </label>
            </div>
            <button type="button" class="pv2-ghost-btn pv2-ghost-btn--compact pv2-ghost-btn--danger" (click)="removerDescontoTamanho(editOpt)"
                    [disabled]="!podeEditarPrecoOpcoes">
              Remover desconto
            </button>
          </ng-container>
          <button type="button" class="pv2-ghost-btn pv2-ghost-btn--compact"
                  *ngIf="editOpt.novoPreco == null && editOpt.percentualDesconto == null"
                  (click)="editOpt.novoPreco = 0; editOpt.percentualDesconto = 0"
                  [disabled]="!podeEditarPrecoOpcoes">
            + Inserir desconto
          </button>
        </ng-container>
      </ng-container>

      <button type="button" class="pv2-primary-btn pv2-full-btn pv2-edit-sheet__save"
              (click)="saveAndCloseEditSheet()"
              [disabled]="!podeEditarAlgumaOpcao">
        Salvar
      </button>

      <button type="button" class="pv2-edit-sheet__delete"
              *ngIf="focusedGroup?.kind !== 'pizza-sizes'"
              (click)="deleteAndCloseEditSheet()"
              [disabled]="!podeEditarEstruturaAdicional">
        <span class="fa fa-trash"></span> Excluir opção
      </button>
    </div>
  </section>

</div>

<div class="pv2-reorder-scrim" *ngIf="reorderSheetOpen" (click)="closeReorderSheet()"></div>
<section class="pv2-reorder-drawer" *ngIf="reorderSheetOpen">
  <div class="pv2-reorder-drawer__content" [class.is-shaking]="reorderShaking">
  <header class="pv2-reorder-drawer__header">
    <button type="button" class="pv2-icon-btn" (click)="closeReorderSheet()">
      <span class="fa fa-arrow-left"></span>
    </button>
    <div>
      <h3>Reordenar adicionais</h3>
      <span>Arraste para reorganizar a ordem</span>
    </div>
  </header>
  <div class="pv2-reorder-drawer__body" cdkDropList [cdkDropListData]="reorderList" (cdkDropListDropped)="onReorderDrop($event)">
    <div class="pv2-reorder-item" *ngFor="let group of reorderList; let i = index" cdkDrag [cdkDragDisabled]="group.kind === 'pizza-sizes'">
      <span class="pv2-reorder-item__index">{{ i + 1 }}</span>
      <div class="pv2-reorder-item__handle" cdkDragHandle>
        <i class="fa fa-grip-vertical"></i>
      </div>
      <div class="pv2-reorder-item__info">
        <strong>{{ group.name }}</strong>
        <span>{{ group.options.length }} opções &middot; {{ group.required ? 'Obrigatório' : 'Opcional' }}</span>
      </div>
      <div class="pv2-reorder-item__badge" [ngClass]="{
        'is-required': group.required,
        'is-single': group.type === 'single',
        'is-multi': group.type === 'multiple'
      }">
        <i class="fa" [ngClass]="{
          'fa-dot-circle': group.type === 'single',
          'fa-plus-circle': group.type === 'multiple',
          'fa-clone': group.type === 'multipleRepeat'
        }"></i>
      </div>
    </div>
  </div>
  <footer class="pv2-reorder-drawer__footer" [class.is-dirty]="reorderDirty">
    <span class="pv2-reorder-drawer__error" *ngIf="reorderErrorMsg">
      <i class="fa fa-exclamation-circle"></i> {{ reorderErrorMsg }}
    </span>
    <button type="button" class="pv2-ghost-btn" (click)="forceCloseReorderSheet()" [disabled]="reorderApplying">Cancelar</button>
    <button type="button" class="pv2-primary-btn" (click)="applyReorder()" [disabled]="!reorderDirty || reorderApplying">
      <i class="fa" [ngClass]="reorderApplying ? 'fa-spinner fa-spin' : 'fa-check'"></i>
      {{ reorderApplying ? 'Salvando...' : 'Aplicar' }}
    </button>
  </footer>
  </div>
</section>

<ng-template #editorLoading>
  <div class="pv2-editor-page" [class.is-embedded]="embedded">
    <div class="pv2-summary-card is-loading">
      <div class="pv2-skel pv2-skel-media"></div>
      <div class="pv2-skel pv2-skel-line"></div>
      <div class="pv2-skel pv2-skel-line pv2-skel-line-md"></div>
      <div class="pv2-skel pv2-skel-line pv2-skel-line-sm"></div>
    </div>
  </div>
</ng-template>
